<template>
  <v-container style="position:relative;overflow-y:auto;display:flex;flex-direction:row;height:inherit;">
    <div style="position:absolute;z-index:5;left:26px;top:26px;width:180px!important" class="">
      <v-btn depressed class="custom-header-btn font-italic font-weight-medium" @click="dialogConfirmCancel = true"> <v-icon> mdi-close </v-icon> {{  $t('global.leave')  }}</v-btn>
      <v-img class="mt-10" :style="imageStyle" :width="previewWidth" :height="previewHeight" :src="imageFromCanvas" style="border:solid 3px white;border-radius:6px;box-shadow: 0px 7px 9px -4px rgba(0,0,0, 0.1), 0px 14px 21px 2px rgba(0,0,0, 0.07), 0px 5px 26px 4px rgba(0,0,0, 0.06) !important;"></v-img>
    </div>
    <v-dialog class="popupMessage" v-model="dialogConfirmCancel" persistent overlay-color="dialog" overlay-opacity="0.8" max-width="350px" transition="scale-transition">
      <v-card class="pa-4">
        <v-card-text class="mt-3 title font-italic" style="color:var(--v-primary-base);">
          {{ $t('userMessage.creation-leave-title') }}
        </v-card-text>
        <v-tooltip open-delay="800ms" bottom color="rgba(var(--new-media-rgb),1)">
          <template v-slot:activator="{ on }">
            <img class="mb-2" style="height:274px;width:274px;" src="@/assets/images/illu_delete_newMedia.png"  v-on="on">
          </template>
          <span>Illustration : Ivan Haidutski</span>
        </v-tooltip>
        <v-card-text class="body-2" style="color:var(--v-primary-base);">
          {{ $t('userMessage.creation-leave-message') }}
        </v-card-text>
        <v-card-text class="font-weight-medium" style="color:var(--v-primary-base);"><v-icon class="mr-1">mdi-alert-circle-outline</v-icon>
          {{ $t('userMessage.media-delete-warning') }}
        </v-card-text>
        <v-card-actions>
          <v-btn large rounded depressed text style="width:45%" @click="dialogConfirmCancel = false">{{ $t('global.cancel') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn large outlined rounded style="width:45%" class="custom-valid-btn new-media" @click="closeModal">{{ $t('global.confirm') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-stepper style="margin-left:180px;height:100%!important;width:inherit;overflow-y:auto;" class="d-inline-block" v-model="stepModel" vertical>
      <v-stepper-step @click="goToPreviousStep(1)" step="1" :complete="stepModel > 1">
        <div class="custom-center">
          <v-img id="iconStep" style="position:relative;margin-right:10px;" contain height="48px" width="72px" :src="currentTheme ? iconStep1.darkSrc : iconStep1.lightSrc"></v-img>
          <div class="headline font-weight-light">
            {{  $t('creation.steps.1') }}
            <v-tooltip color="new_media" right>
              <template v-slot:activator="{on}">
                <v-icon id="goBack" class="ml-1" color="primary" style="opacity:0;visibility:hidden" v-on="on">mdi-undo-variant</v-icon>
              </template>
              <span>{{ $t('global.backStep') }}</span>
            </v-tooltip>
          </div>
        </div>
      </v-stepper-step>
      <v-stepper-content step="1" style="padding-top:0!important;padding-left:0!important">
        <div style="margin-left:20px;display:flex!important;flex-direction:row!important;justify-content:flex-start;max-width:1124px;">
          <div  v-if="hasBanner" class="divObject custom-center pl-3">
            <v-switch inset hide-details color="new_media" class="form-checkbox" :label="$t('creation.checkboxBanner')" v-model="banner"></v-switch>
          </div>
          <div class="divObject custom-center pl-3" style="padding-right:6px!important;">
            <v-switch inset v-model="hasBackgroundColor" hide-details color="new_media" class="form-checkbox" :label="$t('creation.backgroundColor')"></v-switch>
            <v-menu :close-on-content-click="false" offset-y left>
              <template v-slot:activator="{ on }">
                <v-btn :disabled="!hasBackgroundColor" height="24px" width="24px" depressed fab x-small v-on="on" :color="selectedBackgroundColor" @click="setColorPickerVisibility">
                </v-btn>
              </template>
              <v-color-picker v-model="selectedBackgroundColor" canvas-height="100" width="250" mode="hexa" :hide-mode-switch="hideSwitch" class="d-inline-block" ></v-color-picker>
            </v-menu>
          </div>
        </div>
          <v-skeleton-loader :height="canvasHeight" :width="landscapeWidth" v-if="!doneFetchingImage" type="image" class="d-inline-block canvas mb-8" style="margin-top:12px;margin-left:32px">
          </v-skeleton-loader>
          <v-skeleton-loader v-if="hasPortraitScreens && !doneFetchingImage" :height="canvasHeight" :width="portraitWidth" type="image" class="d-inline-block canvas mb-8" style="margin-top:12px;">
          </v-skeleton-loader>
          <v-skeleton-loader v-if="hasLedScreens && !doneFetchingImage" :height="canvasHeight" :width="ledWidth" type="image" class="d-inline-block canvas mb-8" style="margin-top:12px;">
          </v-skeleton-loader>
          <div v-show="doneFetchingImage" class="pb-4" style="position:relative;display:flex;flex-direction:row;overflow-x:auto!important;margin-left:-16px;padding-left:32px">
            <div style="overflow:visible;" id="landscapeScreen"><!-- Landscape Screen -->
              <v-menu v-if="hasLandscapeScreens" :close-on-content-click="true" right attach="#landscapeScreen">
                <template v-slot:activator="{ on: menu }">
                  <v-btn small fab v-on="menu" class="elevation-12" :style="animationStyle" style="position:absolute;top:220px;z-index:2;background-color:var(--v-contrast-base);width:46px!important;height:46px!important;">
                    <v-icon color="var(--v-primary-base)">mdi-crop</v-icon>
                  </v-btn>
                </template>
                <v-btn-toggle group color="rgb(var(--new-media-rgb))" class="custom-center elevation-24" style="display:flex;flex-direction:row;background-color:var(--v-contrast-base);width:184px;height:46px;border-radius:50em;">
                  <v-tooltip color="rgba(var(--new-media-rgb),1)" bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn icon v-on="tooltip" @click="landscapeTopPosition" style="border-radius:50em;min-width:38px!important;height:38px!important;">
                        <v-icon>mdi-arrow-collapse-up</v-icon>
                      </v-btn>
                    </template>
                    <span> {{ $t('creationModal.frames.top') }} </span>
                  </v-tooltip >
                  <v-tooltip color="rgba(var(--new-media-rgb),1)" bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn icon v-on="tooltip" @click="landscapeBottomPosition" style="border-radius:50em;min-width:38px!important;height:38px!important;">
                        <v-icon>mdi-arrow-collapse-down</v-icon>
                      </v-btn>
                    </template>
                    <span> {{ $t('creationModal.frames.bottom') }} </span>
                  </v-tooltip >
                  <v-tooltip color="rgba(var(--new-media-rgb),1)" bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn icon v-on="tooltip" @click="landscapeCenterPosition" style="border-radius:50em;min-width:38px!important;height:38px!important;">
                        <v-icon>mdi-arrow-expand</v-icon>
                      </v-btn>
                    </template>
                    <span> {{ $t('creationModal.frames.center') }} </span>
                  </v-tooltip >
                  <v-tooltip color="rgba(var(--new-media-rgb),1)" bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn icon v-on="tooltip" @click="landscapeFullImage" style="border-radius:50em;min-width:38px!important;height:38px!important;">
                        <v-icon>mdi-arrow-collapse</v-icon>
                      </v-btn>
                    </template>
                    <span> {{ $t('creationModal.frames.full') }} </span>
                  </v-tooltip >
                </v-btn-toggle>
              </v-menu>
              <v-row v-if="hasLandscapeScreens" no-gutters class="pt-3 pb-2" style="position:relative;justify-content:center;">
                <span class="screenType"> {{ $t('global.landscape-screen') }}</span>
                <div class="canvas" id="landscapeCanvas" style="z-index:1;">
                </div>
              </v-row>
            </div>
            <div style="overflow-x:visible" id="portraitScreen"><!-- Portrait Screen -->
              <v-menu v-if="hasPortraitScreens" :close-on-content-click="true" right attach="#portraitScreen">
                <template v-slot:activator="{ on: menu }">
                  <v-btn small fab v-on="menu" class="elevation-12" :style="animationStyle" style="position:absolute;top:220px;z-index:2;background-color:var(--v-contrast-base);width:46px!important;height:46px!important;">
                    <v-icon color="var(--v-primary-base)">mdi-crop</v-icon>
                  </v-btn>
                </template>
                <v-btn-toggle group color="rgb(var(--new-media-rgb))" class="custom-center elevation-24" style="display:flex;flex-direction:row;background-color:var(--v-contrast-base);width:184px;height:46px;border-radius:50em;">
                  <v-tooltip color="rgba(var(--new-media-rgb),1)" bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn icon v-on="tooltip" @click="portraitLeftPosition" style="border-radius:50em;min-width:38px!important;height:38px!important;">
                        <v-icon>mdi-arrow-collapse-left</v-icon>
                      </v-btn>
                    </template>
                    <span> {{ $t('creationModal.frames.left') }} </span>
                  </v-tooltip >
                  <v-tooltip color="rgba(var(--new-media-rgb),1)" bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn icon v-on="tooltip" @click="portraitRightPosition" style="border-radius:50em;min-width:38px!important;height:38px!important;">
                        <v-icon>mdi-arrow-collapse-right</v-icon>
                      </v-btn>
                    </template>
                    <span> {{ $t('creationModal.frames.right') }} </span>
                  </v-tooltip >
                  <v-tooltip color="rgba(var(--new-media-rgb),1)" bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn icon v-on="tooltip" @click="portraitCenterPosition" style="border-radius:50em;min-width:38px!important;height:38px!important;">
                        <v-icon>mdi-arrow-expand</v-icon>
                      </v-btn>
                    </template>
                    <span> {{ $t('creationModal.frames.center') }} </span>
                  </v-tooltip >
                  <v-tooltip color="rgba(var(--new-media-rgb),1)" bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn icon v-on="tooltip" @click="portraitFullImage" style="border-radius:50em;min-width:38px!important;height:38px!important;">
                        <v-icon>mdi-arrow-collapse</v-icon>
                      </v-btn>
                    </template>
                    <span> {{ $t('creationModal.frames.full') }} </span>
                  </v-tooltip >
                </v-btn-toggle>
              </v-menu>
              <v-row v-if="hasPortraitScreens" no-gutters class="pt-3 pb-2" style="position:relative;justify-content:center;">
                <span class="screenType"> {{ $t('global.portrait-screen') }}</span>
                <div class="canvas" id="portraitCanvas" style="z-index:1;">
                </div>
              </v-row>

            </div>
            <div><!-- LED Screen -->
              <v-row v-if="hasLedScreens" no-gutters class="pt-3 pb-2" style="position:relative;justify-content:center;">
                <span class="screenType">{{ $t('global.led-screen') }}</span>
                <div class="canvas" id="ledCanvas" style="z-index:1;"></div>
              </v-row>
          </div>
        </div>
        <div id="custom_tabs" v-if="hasLandscapeScreens">
          <template>
            <v-tabs
              background-color="var(--v-new_media-base)"
              color="white"
              height="38px"
              grow
            >
              <v-tab style="text-transform:none!important;font-size:18px!important;"><v-icon class="mr-2">mdi-format-textbox</v-icon>Blocs texte</v-tab>
              <v-tab-item>
                <div class="divBlock">
                  <div class="divAddBlock" @click="addTextBlock">
                    <SlideButton class="small-btn addBlock ml-5" v-bind:width="textBlockWidth">
                      <template v-slot:icon>
                        mdi-plus
                      </template>
                      <template v-slot:text>
                        Ajouter un bloc texte
                      </template>
                    </SlideButton>
                  </div><transition name="fade" mode="in-out" appear>
                  <transition-group name="textBlocksList" class="justify-end" style="margin-left:10px;display:flex;flex-direction:row-reverse;padding:12px 0px 8px 0px!important;">
                    <template v-for="block in textBlocks">
                      <component :is="block.component" :data="block.id" :key="block.id" class="blocksListItem"></component>
                    </template>
                  </transition-group></transition>
                </div>
              </v-tab-item>
              <v-tab style="text-transform:none!important;font-size:18px!important;"><v-icon class="mr-2">mdi-currency-eur</v-icon>Blocs prix</v-tab>
              <v-tab-item>
                <div class="divBlock">
                  <div class="divAddBlock" @click="addPriceBlock">
                    <SlideButton class="small-btn addBlock ml-5" v-bind:width="priceBlockWidth">
                      <template v-slot:icon>
                        mdi-plus
                      </template>
                      <template v-slot:text>
                        Ajouter un prix
                      </template>
                    </SlideButton>
                  </div>
                  <transition-group name="priceBlocksList" class="justify-end" style="margin-left:10px;display:flex;flex-direction:row-reverse;padding:12px 0px 8px 0px!important;">
                    <template v-for='block in priceBlocks'>
                      <component :is="block.component" :data="block.id" :key="block.id" class="blocksListItem"></component>
                    </template>
                  </transition-group>
                </div>
              </v-tab-item>
              <v-tab style="text-transform:none!important;font-size:18px!important;">
                <v-icon class="pr-2">mdi-sale</v-icon>Infos et promos
              </v-tab>
              <v-tab-item>
                <div class="icon-list">
                  <v-row no-gutters >
                    <template v-for="icon in icons">
                      <v-col :key="icon.id">
                        <div class="icon-list-item d-flex align-center" style="cursor:pointer;" v-if="!selectedIcons.includes(icon)" @click="addIcon(icon)">
                          <v-img class="custom-center" height="100%" width="100%" contain :src="icon.longPath"></v-img>
                          <div style="position:absolute;z-index:1;bottom:0;right:0;">
                            <div >
                              <v-btn small fab dark height="30px" width="30px" color="var(--v-new_media-base)!important" ><v-icon color="white">mdi-plus</v-icon></v-btn>
                            </div>
                          </div>
                        </div>
                        <div class="icon-list-item d-flex align-center" style="cursor:pointer;" v-if="selectedIcons.includes(icon)" @click="removeIcon(icon)">
                          <v-img class="custom-center" height="100%" width="100%" contain :src="icon.longPath"></v-img>
                          <div style="position:absolute;z-index:1;bottom:0;right:0;">
                            <div >
                              <v-btn small fab dark height="30px" width="30px" color="var(--v-primary-base)!important" ><v-icon color="var(--v-contrast-base)!important">mdi-minus</v-icon></v-btn>
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </template>
                  </v-row>
                </div>
              </v-tab-item>
              <v-tab style="text-transform:none!important;font-size:18px!important;">
                <v-icon class="pr-2">mdi-sticker-outline</v-icon>Mes stickers
              </v-tab>
              <v-tab-item>
                <v-card-text flat class="icon-list divBlock">
                  <div style="height:100%;width:100%;" class="d-flex flex-column justify-center align-center"><!--TEMPORAIRE-->
                    <p class="ma-2 text-center subtitle-1">
                      Si vous avez besoin de stickers propres à votre activité,<br>demandez-nous de les ajouter ici pour vous.<br><br> <b>Cette rubrique sera bientôt disponible.</b>
                    </p>
                  </div>
                </v-card-text>
              </v-tab-item>
              <v-tab style="text-transform:none!important;font-size:18px!important;">
                <v-icon class="pr-2">mdi-emoticon</v-icon>Emoticons
              </v-tab>
              <v-tab-item>
                <div class="icon-list">
                  <v-row no-gutters >
                    <template v-for="emote in emoticons">
                      <v-col :key="emote.id">
                        <div class="icon-list-item d-flex align-center" style="cursor:pointer;" v-if="!selectedEmojis.includes(emote)" @click="addEmoji(emote)">
                          <v-img class="custom-center" height="100%" width="100%" contain :src="emote.longPath"></v-img>
                          <div style="position:absolute;z-index:1;bottom:0;right:0;">
                            <div >
                              <v-btn small fab dark height="30px" width="30px" color="var(--v-new_media-base)!important" ><v-icon color="white">mdi-plus</v-icon></v-btn>
                            </div>
                          </div>
                        </div>
                        <div class="icon-list-item d-flex align-center" style="cursor:pointer;" v-if="selectedEmojis.includes(emote)" @click="removeEmoji(emote)">
                          <v-img class="custom-center" height="100%" width="100%" contain :src="emote.longPath"></v-img>
                          <div style="position:absolute;z-index:1;bottom:0;right:0;">
                            <div >
                              <v-btn small fab dark height="30px" width="30px" color="var(--v-primary-base)!important" ><v-icon color="var(--v-contrast-base)!important">mdi-minus</v-icon></v-btn>
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </template>
                  </v-row>
                </div>
              </v-tab-item>
              <v-tab style="text-transform:none!important;font-size:18px!important;">
                <v-icon class="pr-2">mdi-alert-outline</v-icon>Signalétique
              </v-tab>
              <v-tab-item>
                <div class="icon-list">
                  <v-row no-gutters >
                    <template v-for="signal in signals">
                      <v-col :key="signal.id">
                        <div class="icon-list-item d-flex align-center" style="cursor:pointer;" v-if="!selectedEmojis.includes(signal)" @click="addEmoji(signal)">
                          <v-img class="custom-center" height="100%" width="100%" contain :src="signal.longPath"></v-img>
                          <div style="position:absolute;z-index:1;bottom:0;right:0;">
                            <div >
                              <v-btn small fab dark height="30px" width="30px" color="var(--v-new_media-base)!important" ><v-icon color="white">mdi-plus</v-icon></v-btn>
                            </div>
                          </div>
                        </div>
                        <div class="icon-list-item d-flex align-center" style="cursor:pointer;" v-if="selectedEmojis.includes(signal)" @click="removeEmoji(signal)">
                          <v-img class="custom-center" height="100%" width="100%" contain :src="signal.longPath"></v-img>
                          <div style="position:absolute;z-index:1;bottom:0;right:0;">
                            <div >
                              <v-btn small fab dark height="30px" width="30px" color="var(--v-primary-base)!important" ><v-icon color="var(--v-contrast-base)!important">mdi-minus</v-icon></v-btn>
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </template>
                  </v-row>
                </div>
              </v-tab-item>
              <v-tab style="text-transform:none!important;font-size:18px!important;">
                <v-icon class="pr-2">mdi-flag-outline</v-icon>Drapeaux
              </v-tab>
              <v-tab-item>
                <div class="icon-list">
                  <v-row no-gutters >
                    <template v-for="flag in flags">
                      <v-col :key="flag.id">
                        <div class="icon-list-item d-flex align-center" style="cursor:pointer;" v-if="!selectedEmojis.includes(flag)" @click="addEmoji(flag)">
                          <v-img class="custom-center" height="100%" width="100%" contain :src="flag.longPath"></v-img>
                          <div style="position:absolute;z-index:1;bottom:0;right:0;">
                            <div >
                              <v-btn small fab dark height="30px" width="30px" color="var(--v-new_media-base)!important" ><v-icon color="white">mdi-plus</v-icon></v-btn>
                            </div>
                          </div>
                        </div>
                        <div class="icon-list-item d-flex align-center" style="cursor:pointer;" v-if="selectedEmojis.includes(flag)" @click="removeEmoji(flag)">
                          <v-img class="custom-center" height="100%" width="100%" contain :src="flag.longPath"></v-img>
                          <div style="position:absolute;z-index:1;bottom:0;right:0;">
                            <div >
                              <v-btn small fab dark height="30px" width="30px" color="var(--v-primary-base)!important" ><v-icon color="var(--v-contrast-base)!important">mdi-minus</v-icon></v-btn>
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </template>
                  </v-row>
                </div>
              </v-tab-item>
            </v-tabs>
          </template>
        </div>
        <div style="display:flex;flex-direction:row;justify-content:start;margin-top:20px;margin-left:16px">
          <v-btn :disabled="!doneFetchingImage" rounded large depressed color="new_media" style="padding:0px 4px 0px 14px!important;color:white!important;" @click="toStepTwo"> {{  $t('creation.steps.btn-2') }} <v-icon large class="ml-2">mdi-arrow-down-circle</v-icon> </v-btn>
        </div>
      </v-stepper-content>
      <v-stepper-step @click="goToPreviousStep(2)" :complete="stepModel > 2" step="2">
        <div class="custom-center">
          <v-img id="iconStep" style="position:relative;margin-right:10px;" contain height="48px" width="72px" :src="currentTheme ? iconStep2.darkSrc : iconStep2.lightSrc"></v-img>
           <div class="headline font-weight-light"> {{  $t('creation.steps.2') }}
              <v-tooltip color="new_media" right>
                <template v-slot:activator="{on}">
                  <v-icon id="goBack" class="ml-1" color="primary" style="opacity:0;visibility:hidden" v-on="on">mdi-undo-variant</v-icon>
                </template>
                <span>{{ $t('global.backStep') }}</span>
              </v-tooltip>
           </div>
        </div>
      </v-stepper-step>
        <v-stepper-content step="2">
          <div>
            <div class="d-inline-block vert-align-top mr-10">
              <h3 class="mb-2">
                Programmation
              </h3>
              <div class="mb-4 d-flex flex-column">
                <span class="caption text-center">Début de diffusion</span>
                <v-menu
                  ref="startingDate"
                  v-model="menuStartingDate"
                  :close-on-content-click="false"
                  :close-on-click="false"
                  :return-value.sync="startingDate"
                  transition="scale-transition"
                  min-width="290px"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="startingDate"
                      :readonly="true"
                      :hide-details="true"
                      :single-line="true"
                      v-on="on"
                      class="custom-text-field"
                      color="new_media"
                      style="width:180px!important;"
                      prepend-inner-icon="mdi-calendar-check"
                      outlined
                      rounded
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker light color="new_media" style="background-color:white;" first-day-of-week="1" reactive v-model="startingDate" scrollable :locale="$store.state.user.language">
                    <v-btn rounded text style="width:45%;" class="mb-2 ml-2" @click="menuStartingDate = false">Annuler</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn rounded outlined style="width:45%;" class="custom-valid-btn new-media mb-2 mr-2" @click="$refs.startingDate.save(startingDate)">Valider</v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
              <div class="d-flex flex-column">
                <span class="caption text-center">Fin de diffusion</span>
                <v-menu
                  ref="endingDate"
                  v-model="menuEndingDate"
                  :close-on-content-click="false"
                  :close-on-click="false"
                  :return-value.sync="endingDate"
                  transition="scale-transition"
                  min-width="290px"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="endingDate" 
                      placeholder="_ _ _ _-_ _-_ _"
                      :readonly="true"
                      :hide-details="true"
                      :single-line="true"
                      v-on="on"
                      class="custom-text-field"
                      color="new_media"
                      style="width:180px!important;"
                      prepend-inner-icon="mdi-calendar-remove"
                      @click="setDefaultDate"
                      outlined
                      rounded
                      dense
                      clearable
                      clear-icon="mdi-close-circle"
                    ></v-text-field>
                  </template>
                  <v-date-picker light color="new_media" style="background-color:white;" first-day-of-week="1"  reactive v-model="endingDate" scrollable :locale="$store.state.user.language">
                    <v-spacer></v-spacer>
                    <v-btn rounded text style="width:45%;" class="mb-2 ml-2" @click="removeEndingDate">Annuler</v-btn>
                    <v-btn rounded outlined style="width:45%;" class="custom-valid-btn new-media mb-2 mr-2" @click="$refs.endingDate.save(endingDate)">Valider</v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
            </div>
            <div class="d-inline-block broadcast-days-div mr-10">
              <h3 class="mb-2">
                {{ $t('newMedia.broadcastDays') }}
              </h3>
              <div id="broadcastDays_container" style="display:flex; flex-direction:column; height:100%; max-width:380px;">
                  <v-row no-gutters>
                    <template v-for="day in broadcastDays">
                      <v-col :key="day.id" >
                        <div class="divObject custom-center pl-3" style="background-color:transparent;width:180px!important;margin-right:0!important;">
                          <v-switch inset dense hide-details class="form-checkbox" color="new_media" :label="day.name" v-model="chosenDays" :value="day">
                          </v-switch>
                        </div>
                      </v-col>
                    </template>
                  </v-row>
              </div>
            </div>
            <div class="d-inline-block vert-align-top" style="width:280px!important;overflow:visible;">
              <h3 class="mb-2">
                Horaires de diffusion
              </h3>
              <div v-if="setBroadCastHours" class="pt-4 elevation-24-05" style="border-radius:18px;background-color:var(--v-contrast-base)!important;">
                <p class="px-4 text-center">Plage horaire activée<v-icon class="ml-2" color="new_media">mdi-check-circle</v-icon></p>
                <div class="d-flex flex-row justify-space-between px-4 mb-4">
                  <div class="d-flex flex-column">
                    <span class="caption mb-1">Commence à </span>
                    <vue-time-picker :minute-interval="10" class="custom-time-picker" color="new_media" v-model="startingHour">
                    </vue-time-picker>
                  </div>
                  <div class="d-flex flex-column">
                    <span class="caption mb-1">Se termine à </span>
                    <vue-time-picker :minute-interval="10" class="custom-time-picker" color="new_media" v-model="endingHour">
                    </vue-time-picker>
                  </div>
                </div>
                <v-btn
                  depressed
                  block
                  dark
                  color="var(--v-error-darken1)"
                  style="border-radius:0 0 18px 18px;text-transform:none; padding: 0; "
                  @click="removeHours">
                  <v-icon class="mr-2">
                    mdi-chevron-right
                  </v-icon>
                  Supprimer la plage horaire
                  <v-icon class="ml-2">
                    mdi-chevron-left
                  </v-icon>
                </v-btn>
              </div>
              <div v-if="!setBroadCastHours" class="pt-4 elevation-24-05" style="border-radius:18px;background-color:var(--v-contrast-base)!important;">
                <p class="px-4 text-center">
                  Diffusion toute la journée
                  <v-icon class="ml-2" color="new_media">
                    mdi-check-circle
                  </v-icon>
                </p>
                <v-btn
                  depressed
                  block
                  dark
                  color="new_media"
                  class="font-weight-medium"
                  style="border-radius:0 0 18px 18px;text-transform:none; padding: 0;"
                  @click="setBroadCastHours = true">
                <v-icon class="mr-2">
                  mdi-chevron-right
                </v-icon>
                  Activer une plage horaire
                <v-icon class="ml-2">
                  mdi-chevron-left
                </v-icon>
                </v-btn>
              </div>
              <div>
                Durée d'affichage en sec :
                <v-text-field
                  v-model="displayDuration"
                  type="number"
                  class="d-inline-block"
                  style="width:60px;"
                ></v-text-field>
              </div>
            </div>
          </div>
          <div style="height:auto;max-height:500px;;overflow-x:hidden;overflow-y:auto;">
            <div class="d-flex flex-row justify-start" v-if="$store.state.user.id !== 295">
              <h3 class="mr-6">
                Selection des écrans de diffusion ({{ chosenScreens.length }})
              </h3>
              <v-select v-if="$store.state.user.sites.length > 1" :items="availableSites"
                item-text="SitNom"
                item-value="SitId"
                v-model="currentSite"
                append-icon="mdi-chevron-down"
                style="max-width:270px!important;"
                class="pr-3 mr-2 custom"
                return-object
                :hide-details="true"
                rounded
                filled
                dense
                menu-props="auto"
              >
              </v-select>
              <v-switch v-if="$store.state.user.sites.length > 1" inset dense hide-details class="form-checkbox" color="new_media" label="Tous les écrans du site" v-model="allScreensFromCurrentSite" @change="setAllScreensFromCurrentSite">
              </v-switch>
              <v-switch v-if=" $store.state.user.id === 295 || $store.state.user.sites.length === 1" inset dense hide-details class="form-checkbox" color="new_media" label="Tous les écrans" v-model="allScreens" @change="setAllScreens">
              </v-switch>
            </div>
             <div class="d-flex flex-row justify-start" v-if="$store.state.user.id === 295 && $store.state.selectedSite.SitNom === 'Tous'">
              <h3 class="mr-6">
                Selection des groupes de diffusion ({{ selectedCultura.length }})
              </h3>
              <v-switch inset dense hide-details class="form-checkbox" color="new_media" label="Tous les groupes" v-model="allGroups">
              </v-switch>
            </div>
            <div class="d-flex flex-row justify-start">
              <v-switch class="ml-6" v-for="enseigne in tempKazed" @change="addBrandScreens(enseigne)" :key='enseigne.name' :value="enseigne" inset dense hide-details  color="new_media" :label="enseigne.name" v-model="selectedKazed">
              </v-switch>
            </div>  
            <v-row no-gutters v-if="$store.state.user.id !== 295 && $store.state.user.sites.length === 1">
              <template v-for="screen in availableScreens">
                <v-col :key="screen.id" class="align-start col-lg-2 col-md-3 col-sm-6">
                  <div v-if="!chosenScreens.includes(screen)" class="d-flex flex-column justify-center align-center select-screen-container">
                    <div class="elevation-0 select-screen-image-bloc" @click="addScreen(screen)">
                      <v-img class="select-screen-image" contain :src="screenIcon(screen.fk_screen_type)" >
                        <v-btn small fab dark color="var(--v-new_media-base)!important" class="select-screen-button">
                          <v-icon color="white">mdi-plus</v-icon>
                        </v-btn>
                      </v-img>
                    </div>
                    <div >
                      <span> {{ screen.server_name.replace(/_/g, ' ') }} </span>
                    </div>
                  </div>
                  <div v-if="chosenScreens.includes(screen)" class="d-flex flex-column justify-center align-center select-screen-container">
                    <div class="elevation-12 new_media select-screen-image-bloc" style="background-color:var(--v-new_media-base);" @click="removeScreen(screen)">
                      <v-img class="select-screen-image" contain :src="screenIcon(screen.fk_screen_type)" >
                        <v-btn small fab dark color="var(--v-primary-base)!important" class="select-screen-button">
                          <v-icon color="var(--v-contrast-base)!important">mdi-minus</v-icon>
                        </v-btn>
                      </v-img>
                    </div>
                    <div >
                      <span> {{ screen.server_name.replace(/_/g,' ') }} </span>
                    </div>
                  </div>
                </v-col>
              </template>
            </v-row>
            <v-row no-gutters v-if="$store.state.user.id === 295 && $store.state.selectedSite.SitNom === 'Tous'">
              <template v-for="group in tempCultura">
                <v-col :key="group.name" class="align-start col-lg-2 col-md-3 col-sm-6">
                  <div v-if="!selectedCultura.includes(group)" class="d-flex flex-column justify-center align-center select-screen-container">
                    <div class="elevation-0 select-screen-image-bloc" @click="addGroup(group)">
                      <v-img class="select-screen-image" contain :src="screenIcon(group.type)" >
                        <v-btn small fab dark color="var(--v-new_media-base)!important" class="select-screen-button">
                          <v-icon color="white">mdi-plus</v-icon>
                        </v-btn>
                      </v-img>
                    </div>
                    <div >
                      <span> {{ group.name }} </span>
                    </div>
                  </div>
                  <div v-if="selectedCultura.includes(group)" class="d-flex flex-column justify-center align-center select-screen-container">
                    <div class="elevation-12 new_media select-screen-image-bloc" style="background-color:var(--v-new_media-base);" @click="removeGroup(group)">
                      <v-img class="select-screen-image" contain :src="screenIcon(group.type)" >
                        <v-btn small fab dark color="var(--v-primary-base)!important" class="select-screen-button">
                          <v-icon color="var(--v-contrast-base)!important">mdi-minus</v-icon>
                        </v-btn>
                      </v-img>
                    </div>
                    <div >
                      <span> {{ group.name }} </span>
                    </div>
                  </div>
                </v-col>
              </template>
            </v-row>
            <v-row no-gutters v-if="$store.state.user.id !== 295 && $store.state.user.sites.length > 1">             
              <template v-for="screen in availableScreens">
                <v-col :key="screen.id" class="align-start col-lg-2 col-md-3 col-sm-6">
                  <div v-if="!chosenScreens.includes(screen)" class="d-flex flex-column justify-center align-center select-screen-container">
                    <div class="elevation-0 select-screen-image-bloc" @click="addScreen(screen)">
                      <v-img class="select-screen-image" contain :src="screenIcon(screen.fk_screen_type)" >
                        <v-btn small fab dark color="var(--v-new_media-base)!important" class="select-screen-button">
                          <v-icon color="white">mdi-plus</v-icon>
                        </v-btn>
                      </v-img>
                    </div>
                    <div >
                      <span> {{ screen.server_name.replace(/_/g, ' ') }} </span>
                    </div>
                  </div>
                  <div v-if="chosenScreens.includes(screen)" class="d-flex flex-column justify-center align-center select-screen-container">
                    <div class="elevation-12 new_media select-screen-image-bloc" style="background-color:var(--v-new_media-base);" @click="removeScreen(screen)">
                      <v-img class="select-screen-image" contain :src="screenIcon(screen.fk_screen_type)" >
                        <v-btn small fab dark color="var(--v-primary-base)!important" class="select-screen-button">
                          <v-icon color="var(--v-contrast-base)!important">mdi-minus</v-icon>
                        </v-btn>
                      </v-img>
                    </div>
                    <div >
                      <span> {{ screen.server_name.replace(/_/g,' ') }} </span>
                    </div>
                  </div>
                </v-col>
              </template>
            </v-row>
          </div>
          <div>
            <v-btn rounded large depressed color="new_media" style="padding:0px 4px 0px 14px!important;color:white!important;" :disabled="(chosenScreens.length<1  && selectedCultura.length<1) || chosenDays.length<1 || ((!isStartingHourValid || !isEndingHourValid) && setBroadCastHours)" @click="toStepThree">{{  $t('creation.steps.btn-3') }} <v-icon large class="ml-2">mdi-arrow-down-circle</v-icon> </v-btn>
          </div>
        </v-stepper-content>
      <v-stepper-step  step="3">
        <div class="custom-center">
          <v-img id="iconStep" style="position:relative;margin-right:10px;" contain height="48px" width="72px" :src="currentTheme ? iconStep3.darkSrc : iconStep3.lightSrc"></v-img>
           <div class="headline font-weight-light"> {{  $t('creation.steps.3') }}</div>
        </div>
      </v-stepper-step>
      <v-stepper-content step="3">
        <div class="d-inline-flex flex-column">
          <div class="d-inline-flex flex-row elevation-8-05" style="border-radius:10px!important;overflow:hidden;">
            <div class="pa-3 d-inline-flex flex-column justify-center align-end" style="color:white;background-color:var(--v-new_media-base);width:230px;">
              <span>
                <v-icon dark>mdi-calendar-month</v-icon>
                Programmation
              </span>
              <span v-html="schedule" class="font-italic font-weight-regular" style="text-align:right;margin-bottom:10px;"> 
              </span>
              <span>
                <v-icon dark>mdi-calendar-check</v-icon>
                Jours de diffusion
              </span>
              <div class="d-flex flex-row flex-wrap justify-end" style="margin-bottom:10px;">
                <span class="font-italic font-weight-regular text-right" v-html="orderedDays">
                </span>
              </div>
              <div v-if="setBroadCastHours">
                <span >
                  <v-icon dark>mdi-clock-outline</v-icon>
                  Horaires de diffusion
                </span>
                <div class="d-flex flex-row flex-wrap justify-end">
                  <span class="font-italic font-weight-regular">
                    {{ hours }}
                  </span>
                </div>
              </div>
            </div>
            <div v-if="selectedLandscapeScreens.length>0 || selectedLandscapeGroups.length>0"> 
              <v-img v-if="imageFromCanvas" :src="imageFromCanvas" width="480" height="270">
              </v-img>
            </div>
            <div v-if="selectedPortraitScreens.length>0 || selectedPortraitGroups.length>0">
              <v-img v-if="imageFromCanvasPortrait" :src="imageFromCanvasPortrait" width="152" height="270">
              </v-img>
            </div>
            <div v-if="selectedLedScreens.length>0 || selectedLedGroups.length>0">
              <v-img v-if="imageFromCanvasLed" :src="imageFromCanvasLed" width="360" height="270">
              </v-img>
            </div>
          </div>
        </div>
          <div class="d-flex" style="width:450px">
            <v-icon x-large color="new_media">mdi-subdirectory-arrow-right</v-icon>
            <v-text-field
                label="Nommez votre média pour mieux le retrouver !"
                v-model="imageName"
                color="new_media"
                class="mt-4 pt-3 ml-1"
                outlined
                rounded
                dense
              ></v-text-field>
          </div>
          <div class="d-flex custom-center">
            <v-icon color="new_media" large>mdi-television-play</v-icon>
            <h4 class="ml-3 font-weight-medium">Votre média sera diffusé sur le ou les écrans suivants :</h4>
          </div>
          <div class="d-flex custom-center">
            <span class="font-weight-regular"> {{ screenList }} </span>
          </div>

        
        <div style="margin-top:20px;">
          <v-btn rounded :loading="loading" large depressed color="new_media" style="padding:0px 4px 0px 14px!important;color:white!important;" @click="uploadImage" :disabled="imageName === null || imageName === ''">
            Envoyer en diffusion
            <v-icon large class="mx-2">
              mdi-television-play
            </v-icon>
          </v-btn>
          <span class="ml-2">
            {{ uploadMessage }}
          </span>
        </div>
      </v-stepper-content>
    </v-stepper>
  </v-container>
</template>

<script>
import textCreation from './TextCreationComponent'
import priceCreation from './PriceCreationComponent'
import Konva from 'konva'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import FtpService from '@/services/FTPService'
import DBService from '@/services/DBService'
import SlideButton from './SlideButton'
import axios from 'axios'
/* const fs = require('fs') */
const landscapeScale = 480 / 1366
const imagePortraitScale = 270 / 1366
const itemPortraitScale = 480 / 152
var landscapeStage
var landscapeLayer
var portraitStage
var portraitLayer
var ledStage
var ledLayer
var poxYLandscape = 0
var posYLandscape = 0
const blurRadius = 50
/* eslint-disable no-new, new-cap */
export default {
  props: ['isPDF'],
  data () {
    return {
      stepModel: 1,
      textBlocks: [],
      priceBlocks: [],
      file: null,
      imageURL: null,
      image: null,
      icons: [],
      emoticons: [],
      signals: [],
      flags: [],
      startingDate: new Date().toISOString().substr(0, 10),
      endingDate: null,
      menuStartingDate: false,
      menuEndingDate: false,
      imageFromCanvas: '',
      imageFromCanvasPortrait: '',
      imageFromCanvasLed: '',
      textBlocksID: 0,
      priceblockID: 0,
      broadcastDays: [
        { id: 0, code: '', name: this.$i18n.t('global.days.0') },
        { id: 4, code: 'J', name: this.$i18n.t('global.days.4') },
        { id: 1, code: 'L', name: this.$i18n.t('global.days.1') },
        { id: 5, code: 'V', name: this.$i18n.t('global.days.5') },
        { id: 2, code: 'A', name: this.$i18n.t('global.days.2') },
        { id: 6, code: 'S', name: this.$i18n.t('global.days.6') },
        { id: 3, code: 'R', name: this.$i18n.t('global.days.3') },
        { id: 7, code: 'D', name: this.$i18n.t('global.days.7') }
      ],
      chosenDays: [{ id: 0, code: '', name: this.$i18n.t('global.days.0') }],
      nameExtension: '',
      availableScreens: null,
      chosenScreens: [],
      screensbySite: [],
      startingHour: {
        HH: '',
        mm: '00'
      },
      endingHour: {
        HH: '',
        mm: '00'
      },
      displayDuration: '10',
      selectedIcons: [],
      selectedEmojis: [],
      isStartingHourValid: false,
      isEndingHourValid: false,
      resizedLandscapeImage: null,
      resizedPortraitImage: null,
      resizedLedImage: null,
      landscapeThumbnail: null,
      portraitThumbnail: null,
      ledThumbnail: null,
      timeoutDuration: 4000,
      doneFetchingImage: false,
      canvasHeight: 270,
      landscapeWidth: 480,
      portraitWidth: 152,
      ledWidth: 360,
      imageName: '',
      banner: false,
      hasBanner: true,
      iconStep1: {lightSrc: require('../../assets/images/light_ic_creation_step1.png'), darkSrc: require('../../assets/images/dark_ic_creation_step1.png')},
      iconStep2: {lightSrc: require('../../assets/images/light_ic_creation_step2.png'), darkSrc: require('../../assets/images/dark_ic_creation_step2.png')},
      iconStep3: {lightSrc: require('../../assets/images/light_ic_creation_step3.png'), darkSrc: require('../../assets/images/dark_ic_creation_step3.png')},
      imageStyle: 'transform:scale(0);-ms-transform:scale(0); transition: transform 300ms;',
      setBroadCastHours: false,
      currentTheme: null,
      hasLandscapeScreens: false,
      hasPortraitScreens: false,
      hasTwoByFourScreens: false,
      hasLedScreens: false,
      textBlockWidth: '214px',
      priceBlockWidth: '214px',
      eventListeners: [],
      selectedDaysIDCSV: '',
      endingHourFormat: '',
      startingHourFormat: '',
      hideSwitch: true,
      colorVisible: false,
      selectedBackgroundColor: '#FFF',
      hasBackgroundColor: false,
      animationStyle: 'transform:scale(1);-ms-transform:scale(1); transition: transform 300ms; transition-delay: 500ms;',
      currentSelectedLandscapeFraming: 1,
      currentSelectedPortraitFraming: 1,
      imgSrcLandscape: require('@/assets/images/light_ic_screen_landscape.png'),
      imgSrcPortrait: require('@/assets/images/light_ic_screen_portrait.png'),
      imgSrcLED: require('@/assets/images/light_ic_screen_led.png'),
      selectedLandscapeScreens: [],
      selectedPortraitScreens: [],
      selectedLedScreens: [],
      selectedLandscapeGroups: [],
      selectedPortraitGroups: [],
      selectedLedGroups: [],
      previewWidth: 160,
      previewHeight: 90,
      loading: false,
      landscapeBanner: '',
      portraitBanner: '',
      ledBanner: '',
      uploadMessage: '',
      dialogConfirmCancel: false,
      allScreens: false,
      allGroups: false,
      tempKazed: [  
      ],
      selectedKazed: [],
      tempCultura: [  
      ],
      selectedCultura: [],
      hasMultiplePages: false,
      tempLandscape: false,
      availableSites: this.$store.state.user.sites,
      currentSite: this.$store.state.selectedSite,
      allScreensFromCurrentSite: false
    }
  },
  components: {
    'textCreation': textCreation,
    'vueTimePicker': VueTimepicker,
    SlideButton
  },
  created () {
    this.currentTheme = this.$store.state.theme
  },
  async mounted () {
    this.availableScreens = this.$store.state.selectedSite.screens
    if (this.$store.state.selectedSite.SitNom.includes('Kazed')) {
      this.tempKazed = [{name: 'Castorama', prefix: 'Casto_'},
        {name: 'Mr Bricolage', prefix: 'MrBricolage_'},
        {name: 'Entrepôt du bricolage', prefix: 'EDB_'},
        {name: 'BBJ', prefix: 'BBJ_'},
        {name: 'Autre', prefix: ''}]
    } else if (this.$store.state.user.id === 295 && this.$store.state.selectedSite.SitNom.includes('Tous')) {
      var screens = []
      var duplicateCheck = []
      this.$store.state.user.sites.forEach(site => {
        site.screens.forEach(screen => {
          if (!duplicateCheck.includes(screen.name)) {
            duplicateCheck.push(screen.name)
            var screentype = 1
            if (screen.name.toLowerCase().includes('portrait')) {
              screentype = 2
            } else if (screen.name.toLowerCase().includes('led')) {
              screentype = 3
            }
            this.tempCultura.push({
              name: screen.name,
              type: screentype
            })
          }
          screens.push(screen)
        })
      })
      this.availableScreens = screens
    }
    for (let i = 0; i < this.availableSites.length; i++) {
      this.screensbySite.push({
        site: this.availableSites[i],
        screens: []
      })
      this.availableSites[i].screens.forEach(screen => {
        if (screen.fk_screen_type === 4) {
          this.hasPortraitScreens = true
          this.hasTwoByFourScreens = true
          this.portraitWidth = 76
        }
        if (screen.fk_screen_type === 1) {
          this.hasLandscapeScreens = true
        } else if (screen.fk_screen_type === 2) {
          this.hasPortraitScreens = true
        } else if (screen.fk_screen_type === 3) {
          this.hasLedScreens = true
        }
      })
    }
  /*   this.availableScreens.forEach(screen => {
      if (screen.fk_screen_type === 4) {
        this.hasPortraitScreens = true
        this.hasTwoByFourScreens = true
        this.portraitWidth = 76
      }
      if (screen.fk_screen_type === 1) {
        this.hasLandscapeScreens = true
      } else if (screen.fk_screen_type === 2) {
        this.hasPortraitScreens = true
      } else if (screen.fk_screen_type === 3) {
        this.hasLedScreens = true
      }
    })
 */
    if (!this.hasLandscapeScreens) {
      this.hasLandscapeScreens = true
      this.tempLandscape = true
    }
    
    var site = {}
    if (this.$store.state.user.id === 295 && this.$store.state.selectedSite.SitNom.includes('Tous')) {
      site.SitNom = 'Cultura'
    } else {
      site = this.$store.state.selectedSite
    }
    
    const bannerResponse = await FtpService.fetchBanner({
      site: site
    })

    if (bannerResponse.status === 200) {
      if (bannerResponse.data.hasBanner) {
        if (this.hasLandscapeScreens) {
          this.landscapeBanner = 'https://sandisplay.allsan.fr/players/rayontrad/' + site.SitNom + '/bandeau/' + bannerResponse.data.landscapebanner 
        }
        if (this.hasPortraitScreens) {
          this.portraitBanner = 'https://sandisplay.allsan.fr/players/rayontrad/' + site.SitNom + '/bandeau/' + bannerResponse.data.portraitbanner
        }
        if (this.hasLedScreens) {
          this.ledBanner = 'https://sandisplay.allsan.fr/players/rayontrad/' + site.SitNom + '/bandeau/' + bannerResponse.data.ledbanner
        }
      } else {
        this.hasBanner = false
      }
    }
    
    this.file = this.$store.state.file
    
    if (!this.isPDF) {
      if (!this.file) {
        this.imageURL = this.$store.state.pixabayImageURL
        this.setSources()
      } else {
        var reader = new FileReader()
        reader.onload = (e) => {
          this.imageURL = e.target.result
          this.setSources()
        }
        reader.readAsDataURL(this.file)
      }
    } else {
      this.imageURL = 'https://sandisplay.allsan.fr' + this.file
      this.hasMultiplePages = this.file.includes('-0')
      this.doneFetchingImage = true
      this.setSources()
    }
    this.importLocalFiles(require.context('../../assets/images/emojis/Emoticons/', true, /\.svg$/), this.emoticons)
    this.importLocalFiles(require.context('../../assets/images/emojis/Signaletique/', true, /\.svg$/), this.signals)
    this.importLocalFiles(require.context('../../assets/images/emojis/Drapeaux/', true, /\.svg$/), this.flags)
    this.importLocalFiles(require.context('../../assets/images/objects/', true, /\.png$/), this.icons)
  },
  methods: {
    goToPreviousStep (clickedStep) {
      if (this.stepModel > clickedStep) {
        this.stepModel = clickedStep
      }
      if (this.stepModel === 1) {
        this.imageFromCanvas = ''
      }
    },
    closeModal () {
      this.$store.dispatch('setMediaToEdit', null)
      this.$store.dispatch('setFile', null)
      this.$store.dispatch('setPixabayImageID', 0)
      this.$store.dispatch('setUploadSuccessful', false)
      this.$store.dispatch('setPixabayImageURL', null)
      this.$emit('close')
    },
    setAllScreens: function () {
      this.chosenScreens = this.allScreens ? this.availableScreens : []
      var currSite = this.currentSite
      var allScreens = this.chosenScreens
      this.screensbySite.forEach(element => {
        if (element.site.SitId === currSite.SitId) {
          element.screens = this.chosenScreens
        }
      })
    },
    setAllScreensFromCurrentSite () {
      var currSite = this.currentSite
      this.chosenScreens = this.chosenScreens.filter(function (element) {
        if (element.fk_site_id !== currSite.SitId)
          return element
      })
      var isChecked =  this.allScreensFromCurrentSite
      var allScreens = this.availableScreens
      this.screensbySite.forEach(element => {
        if (element.site.SitId === currSite.SitId) {
          element.screens = []
          if (isChecked) {
            element.screens = allScreens
          }
        }
      })
      if (this.allScreensFromCurrentSite) {
        this.chosenScreens = this.chosenScreens.concat(this.availableScreens)
      }
    },
    removeEndingDate () {
      this.menuEndingDate = false
      this.endingDate = null
      this.$refs.endingDate.save(null)
    },
    setDefaultDate () {
      var date = new Date()
      date.setFullYear(this.startingDate.substring(0,4))
      date.setMonth(parseInt(this.startingDate.substring(5,7),10) - 1)
      date.setDate(this.startingDate.substring(8,10))
      var date2 = new Date(date)
      date2.setDate(date2.getDate() + 1)
      this.endingDate = date.getFullYear() + '-' + (date2.getMonth() + 1 >= 10 ? date2.getMonth() + 1 : '0' + (date2.getMonth() + 1).toString()) +  '-' + date2.getDate()
    },
    addTextBlock () {
      this.textBlocksID++
      this.textBlocks.push({id: this.textBlocksID, component: textCreation})
    },
    addPriceBlock () {
      this.priceblockID++
      this.priceBlocks.push({id: this.priceblockID, component: priceCreation})
    },
    importLocalFiles (r, array) {
      var i = 0
      r.keys().forEach(key =>
        (array.push({ id: i++, path: key, longPath: r(key) }))
      )
    },
    toStepTwo () {
      this.stepModel = 2
      this.getHDCanvas(() => {
        
        if (this.hasLandscapeScreens && !this.tempLandscape) {
          this.imageFromCanvas = landscapeStage.toDataURL({
            mimeType: "image/jpeg",
            quality: 0})
        }
        if (this.hasPortraitScreens) {
          if (this.imageFromCanvas === '') {
            this.imageFromCanvas = portraitStage.toDataURL({
              mimeType: "image/jpeg",
              quality: 0})
            this.previewWidth = 90
            this.previewHeight = 160
          }
          this.imageFromCanvasPortrait = portraitStage.toDataURL({
              mimeType: "image/jpeg",
              quality: 0})
        }
        if (this.hasLedScreens) {
          if (this.imageFromCanvas === '') {
            this.imageFromCanvas = ledStage.toDataURL({
              mimeType: "image/jpeg",
              quality: 0})
            this.previewWidth = 120
            this.previewHeight = 90
          }
          this.imageFromCanvasLed = ledStage.toDataURL({
              mimeType: "image/jpeg",
              quality: 0})
        }
      })
      if(this.hasLandscapeScreens) {
        landscapeLayer.find('Transformer').destroy()
      }
      drawLayer()
    },
    toStepThree () {
      this.selectedLandscapeScreens = this.chosenScreens.filter(function (element) {
        return element.fk_screen_type === 1
      })
      this.selectedPortraitScreens = this.chosenScreens.filter(function (element) {
        return element.fk_screen_type === 2 || element.fk_screen_type === 4
      })
      this.selectedLedScreens = this.chosenScreens.filter(function (element) {
        return element.fk_screen_type === 3
      })

      if (this.selectedLandscapeScreens.length > 0 || this.selectedLandscapeGroups.length > 0) {
        this.landscapeThumbnail = landscapeStage.toDataURL({
              mimeType: "image/jpeg",
              quality: 0})
        landscapeStage.width(1366)
        landscapeStage.height(768)
        landscapeStage.scaleX(1 / landscapeScale)
        landscapeStage.scaleY(1 / landscapeScale)
        this.resizedLandscapeImage = landscapeStage.toDataURL({
              mimeType: "image/jpeg",
              quality: 0})
        landscapeStage.scaleX(1)
        landscapeStage.scaleY(1)
        landscapeStage.width(480)
        landscapeStage.height(270)
      }

      if (this.selectedPortraitScreens.length > 0 || this.selectedPortraitGroups.length > 0) {
        if (this.hasTwoByFourScreens) {
          this.portraitThumbnail = portraitStage.toDataURL({
                mimeType: "image/jpeg",
                quality: 0})
          portraitStage.width(608)
          portraitStage.height(2160)
          portraitStage.scaleX(1 / (152 / 608))
          portraitStage.scaleY(1 / (270 / 2160))
          this.resizedPortraitImage = portraitStage.toDataURL({
                mimeType: "image/jpeg",
                quality: 0})
          portraitStage.scaleX(1)
          portraitStage.scaleY(1)
          portraitStage.width(152)
          portraitStage.height(270)
        } else {
          this.portraitThumbnail = portraitStage.toDataURL({
              mimeType: "image/jpeg",
              quality: 0})
          portraitStage.width(768)
          portraitStage.height(1366)
          portraitStage.scaleX(1 / imagePortraitScale)
          portraitStage.scaleY(1 / imagePortraitScale)
          this.resizedPortraitImage = portraitStage.toDataURL({
                mimeType: "image/jpeg",
                quality: 0})
          portraitStage.scaleX(1)
          portraitStage.scaleY(1)
          portraitStage.width(152)
          portraitStage.height(270)
        }
      }

      if (this.selectedLedScreens.length > 0 || this.selectedLedGroups.length > 0) {
        this.resizedLedImage = ledStage.toDataURL({
              mimeType: "image/jpeg",
              quality: 0})
        this.ledThumbnail = this.resizedLedImage
      }

      drawLayer()

      this.stepModel = 3
      this.nameExtension = '__jd'
      this.selectedDaysIDCSV = ''
      for (let i = 0; i < this.chosenDays.length; i++) {
        if (this.chosenDays[i].id === 0) {
          this.selectedDaysIDCSV = '0,'
          this.nameExtension = ''
          break
        } else {
          this.nameExtension += this.chosenDays[i].code
          this.selectedDaysIDCSV += this.chosenDays[i].id + ','
        }
      }
      this.selectedDaysIDCSV = this.selectedDaysIDCSV.substring(0, this.selectedDaysIDCSV.length - 1)
      if (this.setBroadCastHours) {
        if (this.startingHour) {
          let minutes = this.startingHour.mm === '' ? '00' : this.startingHour.mm
          let hours = this.startingHour.HH
          this.nameExtension += '__hd' + hours + minutes
          this.startingHourFormat = hours + minutes
        }
        if (this.endingHour) {
          let minutes = this.endingHour.mm === '' ? '00' : this.endingHour.mm
          let hours = this.endingHour.HH
          this.nameExtension += '__hf' + hours + minutes
          this.endingHourFormat = hours + minutes
        }
      }
      if (this.displayDuration && this.displayDuration !== '10') {
        if (this.displayDuration < 10) {
          this.nameExtension += '__tpf0' + this.displayDuration
        } else {
          this.nameExtension += '__tpf' + this.displayDuration
        }
        
      }
      if (this.startingDate) {
        let dateElements = this.startingDate.split('-')
        this.nameExtension += '__d' + dateElements[0] + dateElements[1] + dateElements[2]
      }
      if (this.endingDate) {
        let dateElements = this.endingDate.split('-')
        this.nameExtension += '__f' + dateElements[0] + dateElements[1] + dateElements[2]
      }
    },
    addBrandScreens(brand) {
      if (this.selectedKazed.includes(brand)) {
        if (brand.prefix === ''){
          this.availableScreens.forEach(screen =>{
            if (!screen.server_name.startsWith('Casto_') &&
            !screen.server_name.startsWith('MrBricolage_') &&
            !screen.server_name.startsWith('EDB_') &&
            !screen.server_name.startsWith('BBJ_')) {
              if (!this.chosenScreens.includes(screen))
                this.chosenScreens.push(screen)
            }
          })
        } else {
          this.availableScreens.forEach(screen =>{
            if (screen.server_name.startsWith(brand.prefix)) {
              if (!this.chosenScreens.includes(screen))
                this.chosenScreens.push(screen)
            }
          })
        }
      } else {
        this.chosenScreens = []
        this.selectedKazed.forEach(enseigne => {
          if (enseigne.prefix === '') {
            this.availableScreens.forEach(screen =>{
              if (!screen.server_name.startsWith('Casto_') &&
              !screen.server_name.startsWith('MrBricolage_') &&
              !screen.server_name.startsWith('EDB_') &&
              !screen.server_name.startsWith('BBJ_')) {
                if (!this.chosenScreens.includes(screen))
                  this.chosenScreens.push(screen)
              }
            })
          } else {
            this.availableScreens.forEach(screen =>{
              if (screen.server_name.startsWith(enseigne.prefix)) {
                if (!this.chosenScreens.includes(screen))
                  this.chosenScreens.push(screen)
              }
            })
          }
        })
      }
    },
    addGroup(group) {
      this.selectedCultura.push(group)
      if (group.type === 1) {
        this.selectedLandscapeGroups.push(group)
      } else if (group.type === 2) {
        this.selectedPortraitGroups.push(group)
      } else {
        this.selectedLedGroups.push(group)
      }
    },
    removeGroup(group) {
      this.selectedCultura = this.selectedCultura.filter(function (element) {
        if (element.name !== group.name) {
          return element
        }
      })
      if (group.type === 1) {
        this.selectedLandscapeGroups = this.selectedLandscapeGroups.filter(function (element) {
          if (element.name !== group.name) {
            return element
          }
        })
      } else if (group.type === 2) {
         this.selectedPortraitGroups = this.selectedPortraitGroups.filter(function (element) {
          if (element.name !== group.name) {
            return element
          }
        })
      } else {
         this.selectedLedGroups = this.selectedLedGroups.filter(function (element) {
          if (element.name !== group.name) {
            return element
          }
        })
      }
    },
    getHDCanvas (callback) {
      this.landscapeStage = {
        width: 1366,
        height: 768,
        scaleX: 1 / landscapeScale,
        scaleY: 1 / landscapeScale
      }
      setTimeout(() => {
        callback()
        this.landscapeStage = {
          width: 480,
          height: 270,
          scaleX: 1,
          scaleY: 1
        }
      }, 0)
    },
    addText (konvaText) {
      if (landscapeLayer.find('#' + konvaText.attrs.id).length > 0) {
        landscapeLayer.find('Transformer').destroy()
        var existingText = landscapeLayer.find('#' + konvaText.attrs.id)[0]
        if (this.hasPortraitScreens) {
          var existingPortraitText = portraitLayer.find('#' + konvaText.attrs.id + '-portrait')[0]
        }
        if (this.hasLedScreens) {
          var existingLedText = ledLayer.find('#' + konvaText.attrs.id + '-led')[0]
        }
        if (!konvaText.attrs.text) {
          existingText.destroy()
          if (this.hasPortraitScreens) {
            if (existingPortraitText) {
              existingPortraitText.destroy()
            }
          }
          if (this.hasLedScreens) {
            if (existingLedText) {
              existingLedText.destroy()
            }
          }
          drawLayer()
        } else {
          existingText.text(konvaText.text())
          existingText.fontFamily(konvaText.fontFamily())
          existingText.fill(konvaText.fill())
          existingText.textDecoration(konvaText.textDecoration())
          existingText.fontStyle(konvaText.fontStyle())
          if (this.hasPortraitScreens) {
            existingPortraitText.text(konvaText.text())
            existingPortraitText.fontStyle(konvaText.fontStyle())
            existingPortraitText.textDecoration(konvaText.textDecoration())
            existingPortraitText.fill(konvaText.fill())
            existingPortraitText.fontFamily(konvaText.fontFamily())
          }
          if (this.hasLedScreens) {
            existingLedText.text(konvaText.text())
            existingLedText.fontStyle(konvaText.fontStyle())
            existingLedText.textDecoration(konvaText.textDecoration())
            existingLedText.fill(konvaText.fill())
            existingLedText.fontFamily(konvaText.fontFamily())
          }
          landscapeLayer.add(new Konva.Transformer({
            node: existingText,
            keepRatio: true,
            enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
            anchorSize: 15,
            rotateAnchorOffset: 30,
            rotationSnaps: [0, 90, 180, 270]
          }))
          drawLayer()
          if (!this.eventListeners.includes(existingText.attrs.id)) {
            this.eventListeners.push(existingText.attrs.id)
            landscapeStage.on('mouseup', () => {
              if (this.hasPortraitScreens) {
                existingPortraitText.scaleX(existingText.scaleX())
                existingPortraitText.scaleY(existingText.scaleY())
              }
              if (this.hasLedScreens) {
                existingLedText.scaleX(existingText.scaleX())
                existingLedText.scaleY(existingText.scaleY())
              }
              var originalAngle = existingText.rotation()
              rotateAroundCenter(existingText, 0)
              var margeDroiteMaxPaysage = 480 - (existingText.width() * existingText.scaleX())
              var margeBasseMaxPaysage = 270 - (existingText.height() * existingText.scaleX())
              var margeDroitePaysage = margeDroiteMaxPaysage - existingText.x()
              var margeBassePaysage = margeBasseMaxPaysage - existingText.y()
              if (this.hasPortraitScreens) {
                rotateAroundCenter(existingPortraitText, 0)
                var widthTextPortrait = existingText.width() * existingText.scaleX() / itemPortraitScale
                var heightTextPortrait = existingText.height() * existingText.scaleY() / itemPortraitScale
                var margeDroiteMaxPortrait = 152 - widthTextPortrait
                var margeBasseMaxPortrait = 270 - heightTextPortrait
                var margeDroitePortrait = margeDroitePaysage * margeDroiteMaxPortrait / margeDroiteMaxPaysage
                var margeBassePortrait = margeBassePaysage * margeBasseMaxPortrait / margeBasseMaxPaysage
                var x0 = 152 - widthTextPortrait - margeDroitePortrait
                var y0 = 270 - heightTextPortrait - margeBassePortrait
                existingPortraitText.x(x0)
                existingPortraitText.y(y0)
                rotateAroundCenter(existingPortraitText, originalAngle)
              }

              if (this.hasLedScreens) {
                rotateAroundCenter(existingLedText, 0)
                var widthTextLed = existingText.width() * existingText.scaleX() * 3 / 4
                var heightTextLed = existingText.height() * existingText.scaleY() * 3 / 4
                var margeDroiteMaxLed = 360 - widthTextLed
                var margeBasseMaxLed = 252 - heightTextLed
                var margeDroiteLed = margeDroitePaysage * margeDroiteMaxLed / margeDroiteMaxPaysage
                var margeBasseLed = margeBassePaysage * margeBasseMaxLed / margeBasseMaxPaysage
                var x0Led = 360 - widthTextLed - margeDroiteLed
                var y0Led = 252 - heightTextLed - margeBasseLed
                existingLedText.x(x0Led)
                existingLedText.y(y0Led)
                rotateAroundCenter(existingLedText, originalAngle)
              }
              rotateAroundCenter(existingText, originalAngle)
              drawLayer()
            })
          }
          drawLayer()
        }
      } else {
        if (!konvaText.text()) {
          return
        }
        if (this.hasPortraitScreens) {
          var portraitKonvaText = konvaText.clone()
          portraitKonvaText.id(konvaText.id() + '-portrait')
          portraitKonvaText.fontSize(konvaText.fontSize() / itemPortraitScale)
          portraitKonvaText.draggable(false)
        }
        if (this.hasLedScreens) {
          var ledKonvaText = konvaText.clone()
          ledKonvaText.id(konvaText.id() + '-led')
          ledKonvaText.fontSize(ledKonvaText.fontSize() * 3 / 4)
          ledKonvaText.draggable(false)
        }
        landscapeStage.on('mouseup', () => {
          if (this.hasPortraitScreens) {
            portraitKonvaText.scaleX(konvaText.scaleX())
            portraitKonvaText.scaleY(konvaText.scaleY())
          }
          if (this.hasLedScreens) {
            ledKonvaText.scaleX(konvaText.scaleX())
            ledKonvaText.scaleY(konvaText.scaleY())
          }

          var originalAngle = konvaText.rotation()
          rotateAroundCenter(konvaText, 0)
          var margeDroiteMaxPaysage = 480 - (konvaText.width() * konvaText.scaleX())
          var margeBasseMaxPaysage = 270 - (konvaText.height() * konvaText.scaleY())
          var margeDroitePaysage = margeDroiteMaxPaysage - konvaText.x()
          var margeBassePaysage = margeBasseMaxPaysage - konvaText.y()

          if (this.hasPortraitScreens) {
            rotateAroundCenter(portraitKonvaText, 0)
            var widthTextPortrait = konvaText.width() * konvaText.scaleX() / itemPortraitScale
            var heightTextPortrait = konvaText.height() * konvaText.scaleY() / itemPortraitScale
            var margeDroiteMaxPortrait = 152 - widthTextPortrait
            var margeBasseMaxPortrait = 270 - heightTextPortrait
            var margeDroitePortrait = margeDroitePaysage * margeDroiteMaxPortrait / margeDroiteMaxPaysage
            var margeBassePortrait = margeBassePaysage * margeBasseMaxPortrait / margeBasseMaxPaysage
            var x0 = 152 - widthTextPortrait - margeDroitePortrait
            var y0 = 270 - heightTextPortrait - margeBassePortrait
            portraitKonvaText.x(x0)
            portraitKonvaText.y(y0)
            rotateAroundCenter(portraitKonvaText, originalAngle)
          }

          if (this.hasLedScreens) {
            rotateAroundCenter(ledKonvaText, 0)
            var widthTextLed = konvaText.width() * konvaText.scaleX() * 3 / 4
            var heightTextLed = konvaText.height() * konvaText.scaleY() * 3 / 4
            var margeDroiteMaxLed = 360 - widthTextLed
            var margeBasseMaxLed = 252 - heightTextLed
            var margeDroiteLed = margeDroitePaysage * margeDroiteMaxLed / margeDroiteMaxPaysage
            var margeBasseLed = margeBassePaysage * margeBasseMaxLed / margeBasseMaxPaysage
            var x0Led = 360 - widthTextLed - margeDroiteLed
            var y0Led = 252 - heightTextLed - margeBasseLed
            ledKonvaText.x(x0Led)
            ledKonvaText.y(y0Led)
            rotateAroundCenter(ledKonvaText, originalAngle)
          }
          rotateAroundCenter(konvaText, originalAngle)
          drawLayer()
        })
        landscapeLayer.add(konvaText)
        if (this.hasPortraitScreens) {
          portraitLayer.add(portraitKonvaText)
        }
        if (this.hasLedScreens) {
          ledLayer.add(ledKonvaText)
        }
        let transformText = new Konva.Transformer({
          node: konvaText,
          keepRatio: true,
          enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
          anchorSize: 15,
          rotateAnchorOffset: 30,
          rotationSnaps: [0, 90, 180, 270]
        })
        landscapeLayer.add(transformText)
        drawLayer()
      }
    },
    addPrice (konvaPriceText, konvaPriceShape, isRectangle) {
      var posXGroupLandscape = 0
      var posYGroupLandscape = 0
      var groupScale = 1
      var konvaPriceTextPortrait
      var konvaPriceTextLed
      var landscapeGroup
      var portraitGroup
      var ledGroup
      var id = konvaPriceText.attrs.id
      if (landscapeLayer.find('#priceBlock' + id).length > 0) {
        var existingGroup = landscapeLayer.find('#priceBlock' + id)[0]
        if (existingGroup.nodeType === 'Group') {
          existingGroup.destroy()
          if (this.hasPortraitScreens) {
            var existingPortraitGroup = portraitLayer.find('#priceBlock-portrait' + id)[0]
            existingPortraitGroup.destroy()
          }
          if (this.hasLedScreens) {
            var existingLedGroup = ledLayer.find('#priceBlock-led' + id)[0]
            existingLedGroup.destroy()
          }
          drawLayer()
        }  
      }
      if (konvaPriceShape === null) {
        if (landscapeLayer.find('#priceBlock' + id).length > 0) {
          landscapeLayer.find('Transformer').destroy()
          var existingPrice = landscapeLayer.find('#priceBlock' + id)[0]
          if (this.hasPortraitScreens) {
            var existingPortraitText = portraitLayer.find('#priceBlock-portrait' + id)[0]
          }
          if (this.hasLedScreens) {
            var existingLedText = ledLayer.find('#priceBlock-led' + id)[0]
          }
          
          if (!konvaPriceText.attrs.text) {
            existingPrice.destroy()
            if (this.hasPortraitScreens) {
              existingPortraitText.destroy()
            }
            if (this.hasLedScreens) {
              existingLedText.destroy()
            }
            drawLayer()
          } else { 
            existingPrice.text(konvaPriceText.text())
            existingPrice.fontFamily(konvaPriceText.fontFamily())
            existingPrice.fill(konvaPriceText.fill())
            existingPrice.textDecoration(konvaPriceText.textDecoration())
            existingPrice.fontStyle(konvaPriceText.fontStyle())
            if (this.hasPortraitScreens) {
              existingPortraitText.text(konvaPriceText.text())
              existingPortraitText.fontStyle(konvaPriceText.fontStyle())
              existingPortraitText.textDecoration(konvaPriceText.textDecoration())
              existingPortraitText.fill(konvaPriceText.fill())
              existingPortraitText.fontFamily(konvaPriceText.fontFamily())
            }
            if (this.hasLedScreens) {
              existingLedText.text(konvaPriceText.text())
              existingLedText.fontStyle(konvaPriceText.fontStyle())
              existingLedText.textDecoration(konvaPriceText.textDecoration())
              existingLedText.fill(konvaPriceText.fill())
              existingLedText.fontFamily(konvaPriceText.fontFamily())
            }
            drawLayer()
            
            landscapeStage.on('mouseup', () => {
              var originalAngle = existingPrice.rotation()
              rotateAroundCenter(existingPrice, 0)
              if (this.hasPortraitScreens) {
                existingPortraitText.scaleX(existingPrice.scaleX())
                existingPortraitText.scaleY(existingPrice.scaleY())
                rotateAroundCenter(existingPortraitText, 0)
                var margeDroiteMaxPaysage = 480 - (existingPrice.width() * existingPrice.scaleX())
                var margeBasseMaxPaysage = 270 - (existingPrice.height() * existingPrice.scaleY())
                var margeDroitePaysage = margeDroiteMaxPaysage - existingPrice.x()
                var margeBassePaysage = margeBasseMaxPaysage - existingPrice.y()
                var widthTextPortrait = existingPrice.width() * existingPrice.scaleX() / itemPortraitScale
                var heightTextPortrait = existingPrice.height() * existingPrice.scaleY() / itemPortraitScale
                var margeDroiteMaxPortrait = 152 - widthTextPortrait
                var margeBasseMaxPortrait = 270 - heightTextPortrait
                var margeDroitePortrait = margeDroitePaysage * margeDroiteMaxPortrait / margeDroiteMaxPaysage
                var margeBassePortrait = margeBassePaysage * margeBasseMaxPortrait / margeBasseMaxPaysage
                var x0 = 152 - widthTextPortrait - margeDroitePortrait
                var y0 = 270 - heightTextPortrait - margeBassePortrait
                existingPortraitText.x(x0)
                existingPortraitText.y(y0)
              }
              if (this.hasLedScreens) {
                existingLedText.scaleX(existingPrice.scaleX())
                existingLedText.scaleY(existingPrice.scaleY())
                rotateAroundCenter(existingLedText, 0)
                var widthTextLed = existingPrice.width() * existingPrice.scaleX() * 3 / 4
                var heightTextLed = existingPrice.height() * existingPrice.scaleY() * 3 / 4
                var margeDroiteMaxLed = 360 - widthTextLed
                var margeBasseMaxLed = 252 - heightTextLed
                var margeDroiteLed = margeDroitePaysage * margeDroiteMaxLed / margeDroiteMaxPaysage
                var margeBasseLed = margeBassePaysage * margeBasseMaxLed / margeBasseMaxPaysage
                var x0Led = 360 - widthTextLed - margeDroiteLed
                var y0Led = 252 - heightTextLed - margeBasseLed
                existingLedText.x(x0Led)
                existingLedText.y(y0Led)
              }
              rotateAroundCenter(konvaPriceText, originalAngle)
              if (this.hasPortraitScreens) {
                rotateAroundCenter(existingPortraitText, konvaPriceText.rotation())
              }
              if (this.hasLedScreens) {
                rotateAroundCenter(existingLedText, konvaPriceText.rotation())
              }
              drawLayer()
            })
          }
        } else {
          if (!konvaPriceText.text()) {
            return
          }
          
          if (this.hasPortraitScreens) {
            var portraitKonvaText = konvaPriceText.clone()
            portraitKonvaText.id('priceBlock-portrait' + konvaPriceText.id())
            portraitKonvaText.draggable(false)
          }
          if (this.hasLedScreens) {
            var ledKonvaText = konvaPriceText.clone()
            ledKonvaText.id('priceBlock-led' + konvaPriceText.id())
            ledKonvaText.draggable(false)
          }
          konvaPriceText.id('priceBlock' + id)
      
          landscapeStage.on('mouseup', () => {
            var originalAngle = konvaPriceText.rotation()
            rotateAroundCenter(konvaPriceText, 0)
            if (this.hasPortraitScreens) {
              portraitKonvaText.scaleX(konvaPriceText.scaleX())
              portraitKonvaText.scaleY(konvaPriceText.scaleY())
              rotateAroundCenter(portraitKonvaText, 0)
              var margeDroiteMaxPaysage = 480 - (konvaPriceText.width() * konvaPriceText.scaleX())
              var margeBasseMaxPaysage = 270 - (konvaPriceText.height() * konvaPriceText.scaleY())
              var margeDroitePaysage = margeDroiteMaxPaysage - konvaPriceText.x()
              var margeBassePaysage = margeBasseMaxPaysage - konvaPriceText.y()
              var widthTextPortrait = konvaPriceText.width() * konvaPriceText.scaleX() / itemPortraitScale
              var heightTextPortrait = konvaPriceText.height() * konvaPriceText.scaleY() / itemPortraitScale
              var margeDroiteMaxPortrait = 152 - widthTextPortrait
              var margeBasseMaxPortrait = 270 - heightTextPortrait
              var margeDroitePortrait = margeDroitePaysage * margeDroiteMaxPortrait / margeDroiteMaxPaysage
              var margeBassePortrait = margeBassePaysage * margeBasseMaxPortrait / margeBasseMaxPaysage
              var x0 = 152 - widthTextPortrait - margeDroitePortrait
              var y0 = 270 - heightTextPortrait - margeBassePortrait
              portraitKonvaText.x(x0)
              portraitKonvaText.y(y0)
            }
            if (this.hasLedScreens) {
              ledKonvaText.scaleX(konvaPriceText.scaleX())
              ledKonvaText.scaleY(konvaPriceText.scaleY())
              rotateAroundCenter(ledKonvaText, 0)
              var widthTextLed = konvaPriceText.width() * konvaPriceText.scaleX() * 3 / 4
              var heightTextLed = konvaPriceText.height() * konvaPriceText.scaleY() * 3 / 4
              var margeDroiteMaxLed = 360 - widthTextLed
              var margeBasseMaxLed = 252 - heightTextLed
              var margeDroiteLed = margeDroitePaysage * margeDroiteMaxLed / margeDroiteMaxPaysage
              var margeBasseLed = margeBassePaysage * margeBasseMaxLed / margeBasseMaxPaysage
              var x0Led = 360 - widthTextLed - margeDroiteLed
              var y0Led = 252 - heightTextLed - margeBasseLed
              ledKonvaText.x(x0Led)
              ledKonvaText.y(y0Led)
            }
            rotateAroundCenter(konvaPriceText, originalAngle)
            if (this.hasPortraitScreens) {
              rotateAroundCenter(portraitKonvaText, konvaPriceText.rotation())
            }
            if (this.hasLedScreens) {
              rotateAroundCenter(ledKonvaText, konvaPriceText.rotation())
            }
            drawLayer()
          })
          landscapeLayer.add(konvaPriceText)
          if (this.hasPortraitScreens) {
            portraitLayer.add(portraitKonvaText)
          }
          if (this.hasLedScreens) {
            ledLayer.add(ledKonvaText)
          }
          let transformText = new Konva.Transformer({
            node: konvaPriceText,
            keepRatio: true,
            enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
            anchorSize: 15,
            rotateAnchorOffset: 30,
            rotationSnaps: [0, 90, 180, 270]
          })
          landscapeLayer.add(transformText)
          drawLayer()
        }
      } else {
        konvaPriceText.id(null)
        if (!isRectangle) {
          if (landscapeLayer.find('#priceBlock' + id).length > 0) {
            landscapeLayer.find('Transformer').destroy()
            posXGroupLandscape = landscapeLayer.find('#priceBlock' + id)[0].x()
            posYGroupLandscape = landscapeLayer.find('#priceBlock' + id)[0].y()
            groupScale = landscapeLayer.find('#priceBlock' + id)[0].scaleX()
            landscapeLayer.find('#priceBlock' + id).destroy()
            if (this.hasPortraitScreens) {
              portraitLayer.find('#priceBlock-portrait' + id).destroy()
            }
            if (this.hasLedScreens) {
              ledLayer.find('#priceBlock-led' + id).destroy()
            }
          }
          if (this.hasPortraitScreens) {
            konvaPriceTextPortrait = konvaPriceText.clone()
            konvaPriceTextPortrait.draggable(false)
            konvaPriceTextPortrait.fontSize(konvaPriceText.fontSize() / itemPortraitScale)
            konvaPriceTextPortrait.x(konvaPriceText.x() / itemPortraitScale)
            konvaPriceTextPortrait.y(konvaPriceText.y() / itemPortraitScale)
            var konvaCirclePortrait = konvaPriceShape.clone()
            konvaCirclePortrait.x(3.5 + konvaPriceText.getWidth() / 2 / itemPortraitScale)
            konvaCirclePortrait.y(3.5 + konvaPriceText.getWidth() / 2 / itemPortraitScale)
            konvaCirclePortrait.radius({
              x: (konvaPriceText.getWidth() / 2 + 3.5) / itemPortraitScale,
              y: (konvaPriceText.getWidth() / 2 + 3.5) / itemPortraitScale
            })
          }
          if (this.hasLedScreens) {
            konvaPriceTextLed = konvaPriceText.clone()
            konvaPriceTextLed.draggable(false)
            konvaPriceTextLed.fontSize(konvaPriceText.fontSize() * 3 / 4)
            konvaPriceTextLed.x(konvaPriceText.x() * 3 / 4)
            konvaPriceTextLed.y(konvaPriceText.y() * 3 / 4)
            var konvaCircleLed = konvaPriceShape.clone()
            konvaCircleLed.x(4.5 + konvaPriceText.getWidth() / 2 * 3 / 4)
            konvaCircleLed.y(4.5 + konvaPriceText.getWidth() / 2 * 3 / 4)
            konvaCircleLed.radius({
              x: (konvaPriceText.getWidth() / 2 + 4.5) * 3 / 4,
              y: (konvaPriceText.getWidth() / 2 + 4.5) * 3 / 4
            })
          }

          landscapeGroup = new Konva.Group({
            id: 'priceBlock' + id,
            x: 0,
            y: 0,
            width: konvaPriceShape.width(),
            height: konvaPriceShape.height(),
            draggable: true,
            listening: true
          })

          if (this.hasPortraitScreens) {
            portraitGroup = new Konva.Group({
              id: 'priceBlock-portrait' + id,
              x: 0,
              y: 0,
              width: konvaPriceShape.width(),
              height: konvaPriceShape.height(),
              draggable: false,
              listening: true
            })
          }
          if (this.hasLedScreens) {
            ledGroup = new Konva.Group({
              id: 'priceBlock-led' + id,
              x: 0,
              y: 0,
              width: konvaPriceShape.width(),
              height: konvaPriceShape.height(),
              draggable: false,
              listening: true
            })
          }
          landscapeGroup.scaleX(groupScale)
          landscapeGroup.scaleY(groupScale)

          if (posYGroupLandscape !== 0 || posXGroupLandscape !== 0) {
            landscapeGroup.x(posXGroupLandscape)
            landscapeGroup.y(posYGroupLandscape)
            var margeDroiteMaxPaysage = 480 - (landscapeGroup.width() * landscapeGroup.scaleX())
            var margeBasseMaxPaysage = 270 - (landscapeGroup.height() * landscapeGroup.scaleY())
            var margeDroitePaysage = margeDroiteMaxPaysage - landscapeGroup.x()
            var margeBassePaysage = margeBasseMaxPaysage - landscapeGroup.y()
            if (this.hasPortraitScreens) {
              let widthTextPortrait = landscapeGroup.width() * landscapeGroup.scaleX() / itemPortraitScale
              let heightTextPortrait = landscapeGroup.height() * landscapeGroup.scaleY() / itemPortraitScale
              let margeDroiteMaxPortrait = 152 - widthTextPortrait
              let margeBasseMaxPortrait = 270 - heightTextPortrait
              let margeDroitePortrait = margeDroitePaysage * margeDroiteMaxPortrait / margeDroiteMaxPaysage
              let margeBassePortrait = margeBassePaysage * margeBasseMaxPortrait / margeBasseMaxPaysage
              let x0 = 152 - widthTextPortrait - margeDroitePortrait
              let y0 = 270 - heightTextPortrait - margeBassePortrait
              portraitGroup.x(x0)
              portraitGroup.y(y0)
            }
            if (this.hasLedScreens) {
              let widthTextLed = landscapeGroup.width() * landscapeGroup.scaleX() * 3 / 4
              let heightTextLed = landscapeGroup.height() * landscapeGroup.scaleY() * 3 / 4
              let margeDroiteMaxLed = 360 - widthTextLed
              let margeBasseMaxLed = 252 - heightTextLed
              let margeDroiteLed = margeDroitePaysage * margeDroiteMaxLed / margeDroiteMaxPaysage
              let margeBasseLed = margeBassePaysage * margeBasseMaxLed / margeBasseMaxPaysage
              let x0Led = 360 - widthTextLed - margeDroiteLed
              let y0Led = 252 - heightTextLed - margeBasseLed
              ledGroup.x(x0Led)
              ledGroup.y(y0Led)
            }
          }
          
          landscapeStage.on('mouseup', function () {
            //  Transformation portrait
            var originalAngle = landscapeGroup.rotation()
            rotateAroundCenter(landscapeGroup, 0)
            if (this.hasPortraitScreens) {
              rotateAroundCenter(portraitGroup, 0)
              var margeDroiteMaxPaysage = 480 - (landscapeGroup.width() * landscapeGroup.scaleX())
              var margeBasseMaxPaysage = 270 - (landscapeGroup.height() * landscapeGroup.scaleY())
              var margeDroitePaysage = margeDroiteMaxPaysage - landscapeGroup.x()
              var margeBassePaysage = margeBasseMaxPaysage - landscapeGroup.y()
              var widthTextPortrait = landscapeGroup.width() * landscapeGroup.scaleX() / itemPortraitScale
              var heightTextPortrait = landscapeGroup.height() * landscapeGroup.scaleY() / itemPortraitScale
              var margeDroiteMaxPortrait = 152 - widthTextPortrait
              var margeBasseMaxPortrait = 270 - heightTextPortrait
              var margeDroitePortrait = margeDroitePaysage * margeDroiteMaxPortrait / margeDroiteMaxPaysage
              var margeBassePortrait = margeBassePaysage * margeBasseMaxPortrait / margeBasseMaxPaysage
              var x0 = 152 - widthTextPortrait - margeDroitePortrait
              var y0 = 270 - heightTextPortrait - margeBassePortrait
              portraitGroup.x(x0)
              portraitGroup.y(y0)
              rotateAroundCenter(portraitGroup, originalAngle)
            }
            if (this.hasLedScreens) {
              //  Transformation led
              rotateAroundCenter(ledGroup, 0)
              var widthTextLed = landscapeGroup.width() * landscapeGroup.scaleX() * 3 / 4
              var heightTextLed = landscapeGroup.height() * landscapeGroup.scaleY() * 3 / 4
              var margeDroiteMaxLed = 360 - widthTextLed
              var margeBasseMaxLed = 252 - heightTextLed
              var margeDroiteLed = margeDroitePaysage * margeDroiteMaxLed / margeDroiteMaxPaysage
              var margeBasseLed = margeBassePaysage * margeBasseMaxLed / margeBasseMaxPaysage
              var x0Led = 360 - widthTextLed - margeDroiteLed
              var y0Led = 252 - heightTextLed - margeBasseLed
              ledGroup.x(x0Led)
              ledGroup.y(y0Led)
              rotateAroundCenter(ledGroup, originalAngle)
            }
            rotateAroundCenter(landscapeGroup, originalAngle)
            drawLayer()
          })

          landscapeGroup.add(konvaPriceShape)
          landscapeGroup.add(konvaPriceText)

          if (this.hasPortraitScreens) {
            portraitGroup.add(konvaCirclePortrait)
            portraitGroup.add(konvaPriceTextPortrait)
          }
          if (this.hasLedScreens) {
            ledGroup.add(konvaCircleLed)
            ledGroup.add(konvaPriceTextLed)
          }
          if (poxYLandscape !== 0 || posYLandscape !== 0) {
            landscapeGroup.x(poxYLandscape)
            landscapeGroup.y(posYLandscape)
          }

          let transformGroup = new Konva.Transformer({
            node: landscapeGroup,
            keepRatio: true,
            enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
            anchorSize: 15,
            rotateEnabled: false
          })

          landscapeLayer.add(transformGroup)
          landscapeLayer.add(landscapeGroup)

          if (this.hasPortraitScreens) {
            portraitLayer.add(portraitGroup)
          }
          if (this.hasLedScreens) {
            ledLayer.add(ledGroup)
          }
          drawLayer()
        } else if (isRectangle) {
          if (landscapeLayer.find('#priceBlock' + id).length > 0) {
            landscapeLayer.find('Transformer').destroy()
            groupScale = landscapeLayer.find('#priceBlock' + id)[0].scaleX()
            posXGroupLandscape = landscapeLayer.find('#priceBlock' + id)[0].x()
            posYGroupLandscape = landscapeLayer.find('#priceBlock' + id)[0].y()
            landscapeLayer.find('#priceBlock' + id).destroy()
            if (this.hasPortraitScreens) {
              portraitLayer.find('#priceBlock-portrait' + id).destroy()
            }
            if (this.hasLedScreens) {
              ledLayer.find('#priceBlock-led' + id).destroy()
            }
          }
          if (this.hasPortraitScreens) {
            konvaPriceTextPortrait = konvaPriceText.clone()
            konvaPriceTextPortrait.draggable(false)
          }
          if (this.hasLedScreens) {
            konvaPriceTextLed = konvaPriceText.clone()
            konvaPriceTextLed.draggable(false)
          }
          if (this.hasPortraitScreens) {
            konvaPriceTextPortrait.fontSize(konvaPriceText.fontSize() / itemPortraitScale)
            konvaPriceTextPortrait.x(4)
            konvaPriceTextPortrait.y(konvaPriceText.y() / itemPortraitScale)
            var konvaRectPortrait = konvaPriceShape.clone()
            konvaRectPortrait.width(konvaPriceShape.width() / itemPortraitScale)
            konvaRectPortrait.height(konvaPriceShape.height() / itemPortraitScale)
          }
          if (this.hasLedScreens) {
            konvaPriceTextLed.fontSize(konvaPriceText.fontSize() * 3 / 4)
            konvaPriceTextLed.x(6)
            konvaPriceTextLed.y(konvaPriceText.y() * 3 / 4)
            var konvaRectLed = konvaPriceShape.clone()
            konvaRectLed.width(konvaPriceShape.width() * 3 / 4)
            konvaRectLed.height(konvaPriceShape.height() * 3 / 4)
          }
          landscapeGroup = new Konva.Group({
            id: 'priceBlock' + id,
            x: posXGroupLandscape,
            y: posYGroupLandscape,
            width: konvaPriceShape.width(),
            height: konvaPriceShape.height(),
            draggable: true,
            listening: true
          })
          if (this.hasPortraitScreens) {
            portraitGroup = new Konva.Group({
              id: 'priceBlock-portrait' + id,
              x: 0,
              y: 0,
              width: konvaPriceShape.width(),
              height: konvaPriceShape.height(),
              draggable: false,
              listening: true
            })
          }
          if (this.hasLedScreens) {
            ledGroup = new Konva.Group({
              id: 'priceBlock-led' + id,
              x: 0,
              y: 0,
              width: konvaPriceShape.width(),
              height: konvaPriceShape.height(),
              draggable: false,
              listening: true
            })
          }
          landscapeGroup.scaleX(groupScale)
          landscapeGroup.scaleY(groupScale)
          if (posXGroupLandscape !== 0 || posYGroupLandscape !== 0) {
            landscapeGroup.x(posXGroupLandscape)
            landscapeGroup.y(posYGroupLandscape)
            if (this.hasPortraitScreens) {
              let margeDroiteMaxPaysage = 480 - (landscapeGroup.width() * landscapeGroup.scaleX())
              let margeBasseMaxPaysage = 270 - (landscapeGroup.height() * landscapeGroup.scaleY())
              let margeDroitePaysage = margeDroiteMaxPaysage - landscapeGroup.x()
              let margeBassePaysage = margeBasseMaxPaysage - landscapeGroup.y()
              let widthTextPortrait = landscapeGroup.width() * landscapeGroup.scaleX() / itemPortraitScale
              let heightTextPortrait = landscapeGroup.height() * landscapeGroup.scaleY() / itemPortraitScale
              let margeDroiteMaxPortrait = 152 - widthTextPortrait
              let margeBasseMaxPortrait = 270 - heightTextPortrait
              let margeDroitePortrait = margeDroitePaysage * margeDroiteMaxPortrait / margeDroiteMaxPaysage
              let margeBassePortrait = margeBassePaysage * margeBasseMaxPortrait / margeBasseMaxPaysage
              let x0 = 152 - widthTextPortrait - margeDroitePortrait
              let y0 = 270 - heightTextPortrait - margeBassePortrait
              portraitGroup.x(x0)
              portraitGroup.y(y0)
            }
            if (this.hasLedScreens) {
              let widthTextLed = landscapeGroup.width() * landscapeGroup.scaleX() * 3 / 4
              let heightTextLed = landscapeGroup.height() * landscapeGroup.scaleY() * 3 / 4
              let margeDroiteMaxLed = 360 - widthTextLed
              let margeBasseMaxLed = 252 - heightTextLed
              let margeDroiteLed = margeDroitePaysage * margeDroiteMaxLed / margeDroiteMaxPaysage
              let margeBasseLed = margeBassePaysage * margeBasseMaxLed / margeBasseMaxPaysage
              let x0Led = 360 - widthTextLed - margeDroiteLed
              let y0Led = 252 - heightTextLed - margeBasseLed
              ledGroup.x(x0Led)
              ledGroup.y(y0Led)
            }
          }
          landscapeStage.on('mouseup', function () {
            //  Transformation portrait
            var originalAngle = landscapeGroup.rotation()
            rotateAroundCenter(landscapeGroup, 0)
            if (this.hasPortraitScreens) {
              rotateAroundCenter(portraitGroup, 0)
              var margeDroiteMaxPaysage = 480 - (landscapeGroup.width() * landscapeGroup.scaleX())
              var margeBasseMaxPaysage = 270 - (landscapeGroup.height() * landscapeGroup.scaleY())
              var margeDroitePaysage = margeDroiteMaxPaysage - landscapeGroup.x()
              var margeBassePaysage = margeBasseMaxPaysage - landscapeGroup.y()
              var widthTextPortrait = landscapeGroup.width() * landscapeGroup.scaleX() / itemPortraitScale
              var heightTextPortrait = landscapeGroup.height() * landscapeGroup.scaleY() / itemPortraitScale
              var margeDroiteMaxPortrait = 152 - widthTextPortrait
              var margeBasseMaxPortrait = 270 - heightTextPortrait
              var margeDroitePortrait = margeDroitePaysage * margeDroiteMaxPortrait / margeDroiteMaxPaysage
              var margeBassePortrait = margeBassePaysage * margeBasseMaxPortrait / margeBasseMaxPaysage
              var x0 = 152 - widthTextPortrait - margeDroitePortrait
              var y0 = 270 - heightTextPortrait - margeBassePortrait
              portraitGroup.x(x0)
              portraitGroup.y(y0)
              rotateAroundCenter(portraitGroup, originalAngle)
            }
            if (this.hasLedScreens) {
              //  Transformation led
              rotateAroundCenter(ledGroup, 0)
              var widthTextLed = landscapeGroup.width() * landscapeGroup.scaleX() * 3 / 4
              var heightTextLed = landscapeGroup.height() * landscapeGroup.scaleY() * 3 / 4
              var margeDroiteMaxLed = 360 - widthTextLed
              var margeBasseMaxLed = 252 - heightTextLed
              var margeDroiteLed = margeDroitePaysage * margeDroiteMaxLed / margeDroiteMaxPaysage
              var margeBasseLed = margeBassePaysage * margeBasseMaxLed / margeBasseMaxPaysage
              var x0Led = 360 - widthTextLed - margeDroiteLed
              var y0Led = 252 - heightTextLed - margeBasseLed
              ledGroup.x(x0Led)
              ledGroup.y(y0Led)
              rotateAroundCenter(ledGroup, originalAngle)
            }
            rotateAroundCenter(landscapeGroup, originalAngle)
            drawLayer()
          })

          landscapeGroup.add(konvaPriceShape)
          landscapeGroup.add(konvaPriceText)
          if (this.hasPortraitScreens) {
            portraitGroup.add(konvaRectPortrait)
            portraitGroup.add(konvaPriceTextPortrait)
          }
          if (this.hasLedScreens) {
            ledGroup.add(konvaRectLed)
            ledGroup.add(konvaPriceTextLed)
          }
          let transformGroup = new Konva.Transformer({
            node: landscapeGroup,
            keepRatio: true,
            enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
            anchorSize: 15,
            rotateEnabled: false
          })
          landscapeLayer.add(transformGroup)

          landscapeLayer.add(landscapeGroup)
          if (this.hasPortraitScreens) {
            portraitLayer.add(portraitGroup)
          }
          if (this.hasLedScreens) {
            ledLayer.add(ledGroup)
          }
          drawLayer()
        }
      }
    },
    addPriceWithText (group, id) {
      if (group === null) {
        if (landscapeLayer.find('#priceBlock' + id).length > 0) {
          var existingGroup = landscapeLayer.find('#priceBlock' + id)[0]
          existingGroup.destroy()
        }
        if (portraitLayer.find('#priceBlock-portrait' + id).length > 0) {
          var existingGroupPortrait = portraitLayer.find('#priceBlock-portrait' + id)[0]
          existingGroupPortrait.destroy()
        }
        if (ledLayer.find('#priceBlock-led' + id).length > 0) {
          var existingGroupLed = ledLayer.find('#priceBlock-led' + id)[0]
          existingGroupLed.destroy()
        }
        drawLayer()
        return
      }
      var x1, y1, x2, y2, x3, y3 = 0
      var portraitGroup, ledGroup
      if (this.hasLandscapeScreens) {
        landscapeLayer.find('Transformer').destroy()
        if (landscapeLayer.find('#priceBlock' + id).length > 0) {
          var existingGroup = landscapeLayer.find('#priceBlock' + id)[0]
          x1 = existingGroup.x()
          y1 = existingGroup.y()
          existingGroup.destroy()
        }
      }
      if (this.hasPortraitScreens) {
        if (portraitLayer.find('#priceBlock-portrait' + id).length > 0) {
          var existingGroup = portraitLayer.find('#priceBlock-portrait' + id)[0]
          x2 = existingGroup.x()
          y2 = existingGroup.y()
          existingGroup.destroy()
        }
      }
      if (this.hasLedScreens) {
        if (ledLayer.find('#priceBlock-led' + id).length > 0) {
          var existingGroup = ledLayer.find('#priceBlock-led' + id)[0]
          x3 = existingGroup.x()
          y3 = existingGroup.y()
          existingGroup.destroy()
        }
      }
      group.x(x1)
      group.y(y1)
      landscapeLayer.add(group)
      landscapeLayer.draw()
     
      if (this.hasPortraitScreens) {
        portraitGroup = group.clone()
        portraitGroup.id('priceBlock-portrait' + id)
        portraitGroup.scaleX(group.scaleX() / itemPortraitScale)
        portraitGroup.scaleY(group.scaleY() / itemPortraitScale)
        portraitGroup.x(x2)
        portraitGroup.y(y2)
        portraitLayer.add(portraitGroup)
        portraitLayer.draw()
      }
      if (this.hasLedScreens) {
        ledGroup = group.clone()
        ledGroup.id('priceBlock-led' + id)
        ledGroup.scaleX(group.scaleX() * 3 / 4)
        ledGroup.scaleY(group.scaleY() * 3 / 4)
        ledGroup.x(x3)
        ledGroup.y(y3) 
        ledLayer.add(ledGroup)
        ledLayer.draw()
      }
      landscapeStage.on('mouseup', () => {
        var originalAngle = group.rotation()
        rotateAroundCenter(group, 0)
        var margeDroiteMaxPaysage = 480 - (group.width() * group.scaleX())
        var margeBasseMaxPaysage = 270 - (group.height() * group.scaleY())
        var margeDroitePaysage = margeDroiteMaxPaysage - group.x()
        var margeBassePaysage = margeBasseMaxPaysage - group.y()
        if (this.hasPortraitScreens) {
          rotateAroundCenter(portraitGroup, 0)
          portraitGroup.scaleX(group.scaleX() / itemPortraitScale)
          portraitGroup.scaleY(group.scaleY() / itemPortraitScale)
          var widthTextPortrait = group.width() * group.scaleX() / itemPortraitScale
          var heightTextPortrait = group.height() * group.scaleY() / itemPortraitScale
          var margeDroiteMaxPortrait = 152 - widthTextPortrait
          var margeBasseMaxPortrait = 270 - heightTextPortrait
          var margeDroitePortrait = margeDroitePaysage * margeDroiteMaxPortrait / margeDroiteMaxPaysage
          var margeBassePortrait = margeBassePaysage * margeBasseMaxPortrait / margeBasseMaxPaysage
          var x0 = 152 - widthTextPortrait - margeDroitePortrait
          var y0 = 270 - heightTextPortrait - margeBassePortrait
          portraitGroup.x(x0)
          portraitGroup.y(y0)
          rotateAroundCenter(portraitGroup, originalAngle)
        }
        if (this.hasLedScreens) {
          //  Transformation led
          rotateAroundCenter(ledGroup, 0)
          ledGroup.scaleX(group.scaleX() * 3 / 4)
          ledGroup.scaleY(group.scaleY() * 3 / 4)
          var widthTextLed = group.width() * group.scaleX() * 3 / 4
          var heightTextLed = group.height() * group.scaleY() * 3 / 4
          var margeDroiteMaxLed = 360 - widthTextLed
          var margeBasseMaxLed = 252 - heightTextLed
          var margeDroiteLed = margeDroitePaysage * margeDroiteMaxLed / margeDroiteMaxPaysage
          var margeBasseLed = margeBassePaysage * margeBasseMaxLed / margeBasseMaxPaysage
          var x0Led = 360 - widthTextLed - margeDroiteLed
          var y0Led = 252 - heightTextLed - margeBasseLed
          ledGroup.x(x0Led)
          ledGroup.y(y0Led)
          rotateAroundCenter(ledGroup, originalAngle)
        }
        rotateAroundCenter(group, originalAngle)
        drawLayer()
      })
    },
    async uploadImage () {
      //   Etat : 0 = en pause, 1 = En diffusion/dépassé
      setTimeout( () => {
        this.uploadMessage = 'La durée de cette opération dépend de votre connexion Internet.'
      }, 1000)
      this.loading = true
      var random = Math.floor(Math.random() * Math.floor(4)) + 1
      var byteCharactersLandscape = this.resizedLandscapeImage ? this.resizedLandscapeImage.split(',')[1] : null
      var byteCharactersPortrait = this.resizedPortraitImage ? this.resizedPortraitImage.split(',')[1] : null
      var byteCharactersLed = this.resizedLedImage ? this.resizedLedImage.split(',')[1] : null
      var byteThumbnailLandscape = this.landscapeThumbnail ? this.landscapeThumbnail.split(',')[1] : null
      var byteThumbnailPortrait = this.portraitThumbnail ? this.portraitThumbnail.split(',')[1] : null
      var byteThumbnailLed= this.ledThumbnail ? this.ledThumbnail.split(',')[1] : null
      var uniqueID = Date.now()
      var landscapeData, portraitData, ledData
      landscapeData = this.hasLandscapeScreens ? landscapeLayer.toJSON() : ''
      portraitData = this.hasPortraitScreens? portraitLayer.toJSON() : ''
      ledData = this.hasLedScreens ? ledLayer.toJSON() : ''
      var propertiesDataObject = {
        jsonDataCanvas: landscapeData,
        jsonDataCanvasPortrait: portraitData,
        jsonDataCanvasLed: ledData,
        titre: this.imageName,
        bandeauEnseigne: this.banner,
        etat: 1,
        selectedDays: this.selectedDaysIDCSV,
        dateDebut: this.startingDate,
        dateFin: this.endingDate,
        heureDebut: this.startingHourFormat,
        heureFin: this.endingHourFormat,
        tpf: this.displayDuration,
        pixabayID: this.$store.state.pixabayImageID,
        cadrage_paysage: this.currentSelectedLandscapeFraming,
        cadrage_portrait: this.currentSelectedPortraitFraming
      }
      if (this.$store.state.user.id === 295 && this.$store.state.selectedSite.SitNom === 'Tous') {
        var uploadSuccessful = true 
        if (!this.isPDF || !this.hasMultiplePages) {
          if(this.selectedLandscapeGroups.length > 0) {
            const responseLandscape = await FtpService.uploadToCultura({
              b64: byteCharactersLandscape,
              imageSettings: this.nameExtension,
              groups: this.selectedLandscapeGroups,
              uniqueID: uniqueID
            })
            const responseLandscapeThumbnail = await FtpService.createThumbnailCultura({ 
              b64: byteThumbnailLandscape,
              imageSettings: this.nameExtension,
              groups: this.selectedLandscapeGroups,
              uniqueID: uniqueID
            })
            if (responseLandscape) {
              uploadSuccessful = uploadSuccessful && (responseLandscape.status === 200)
            }
          }    
          if(this.selectedPortraitGroups.length > 0) {
            const responsePortrait = await FtpService.uploadToCultura({
              b64: byteCharactersPortrait,
              imageSettings: this.nameExtension,
              groups: this.selectedPortraitGroups,
              uniqueID: uniqueID
            })
            const responsePortraitThumbnail = await FtpService.createThumbnailCultura({ 
              b64: byteThumbnailPortrait,
              imageSettings: this.nameExtension,
              groups: this.selectedPortraitGroups,
              uniqueID: uniqueID
            })
            if (responsePortrait) {
              uploadSuccessful = uploadSuccessful && (responsePortrait.status === 200)
            }
          }    
          if(this.selectedLedGroups.length > 0) {
            const responseLed = await FtpService.uploadToCultura({
              b64: byteCharactersLed,
              imageSettings: this.nameExtension,
              groups: this.selectedLedGroups,
              uniqueID: uniqueID
            })
            const responseLedThumbnail = await FtpService.createThumbnailCultura({ 
              b64: byteThumbnailLed,
              imageSettings: this.nameExtension,
              groups: this.selectedLedGroups,
              uniqueID: uniqueID
            })
            if (responseLed) {
              uploadSuccessful = uploadSuccessful && (responseLed.status === 200)
            }
            if (uploadSuccessful) {
              const dbResponse = await DBService.registerMediaPropertiesCultura({
                imageSettings: this.nameExtension,
                groups: this.selectedCultura,
                propertiesData: propertiesDataObject,
                uniqueID: uniqueID,
                user: this.$store.state.user.id,
                isVideo: false,
                random: random
              })
              if (dbResponse) {
                if (dbResponse.status === 200) {
                  this.$store.dispatch('setUploadSuccessful', true)
                  this.$emit('close')
                  this.$router.replace({
                    name: 'MyContent'
                  })
                }
              }
            } else {
              this.snackbarUploadFailed = true
            }
          }    
        } else {
          var parts = this.file.split('/')
          var pdfName = parts[2]
          var pdfUniqueID = pdfName.split('-0')[0]
          const responsePDFUpload = await FtpService.uploadMultiplePDFToCultura({
            uniqueID: pdfUniqueID,
            b64: '',
            groups: this.selectedLandscapeScreens,
            dimension: '1366:768',
            settings: this.nameExtension
          })
        }
      } else {
        if (this.availableSites.length === 1) {
          var uploadSuccessful = true 
          if (!this.isPDF || !this.hasMultiplePages) {
            if (this.selectedLandscapeScreens.length > 0) {
              const responseLandscape = await FtpService.uploadImage({ b64: byteCharactersLandscape,
                imageSettings: this.nameExtension,
                site: this.$store.state.selectedSite,
                screens: this.selectedLandscapeScreens,
                uniqueID: uniqueID,
                random: random
              })
              const responseLandscapeThumbnail = await FtpService.createThumbnail({ b64: byteThumbnailLandscape,
                imageSettings: this.nameExtension,
                site: this.$store.state.selectedSite,
                screens: this.selectedLandscapeScreens,
                uniqueID: uniqueID
              })
              if (responseLandscape) {
                uploadSuccessful = uploadSuccessful && (responseLandscape.status === 200)
              }
            }
            if (this.selectedPortraitScreens.length > 0) {
              const responsePortrait = await FtpService.uploadImage({ b64: byteCharactersPortrait,
                imageSettings: this.nameExtension,
                site: this.$store.state.selectedSite,
                screens: this.selectedPortraitScreens,
                uniqueID: uniqueID,
                random: random
              })
              const responsePortraitThumbnail = await FtpService.createThumbnail({ b64: byteThumbnailPortrait,
                imageSettings: this.nameExtension,
                site: this.$store.state.selectedSite,
                screens: this.selectedPortraitScreens,
                uniqueID: uniqueID,
              })
              if (responsePortrait) {
                uploadSuccessful = uploadSuccessful && (responsePortrait.status === 200)
              }
            }
            if (this.selectedLedScreens.length > 0) {
              const responseLed = await FtpService.uploadImage({ b64: byteCharactersLed,
                imageSettings: this.nameExtension,
                site: this.$store.state.selectedSite,
                screens: this.selectedLedScreens,
                uniqueID: uniqueID,
                random: random
              })
              const responseLedThumbnail = await FtpService.createThumbnail({ b64: byteThumbnailLed,
                imageSettings: this.nameExtension,
                site: this.$store.state.selectedSite,
                screens: this.selectedLedScreens,
                uniqueID: uniqueID
              })
              if (responseLed) {
                uploadSuccessful = uploadSuccessful && (responseLed.status === 200)
              }
            }
            if (uploadSuccessful) {
              const dbResponse = await DBService.registerMediaProperties({
                imageSettings: this.nameExtension,
                site: this.$store.state.selectedSite,
                screens: this.chosenScreens,
                propertiesData: propertiesDataObject,
                uniqueID: uniqueID,
                user: this.$store.state.user.id,
                isVideo: false,
                random: random
              })
              if (dbResponse) {
                if (dbResponse.status === 200) {
                  this.$store.dispatch('setUploadSuccessful', true)
                  this.$emit('close')
                  this.$router.replace({
                    name: 'MyContent'
                  })
                }
              }
            } else {
              this.snackbarUploadFailed = true
            }
          } else {
            var parts = this.file.split('/')
            var pdfName = parts[2]
            var pdfUniqueID = pdfName.split('-0')[0]
            const responsePDFUpload = await FtpService.uploadMultiplePDF({
              uniqueID: pdfUniqueID,
              screens: this.selectedLandscapeScreens,
              site: this.$store.state.selectedSite,
              settings: this.nameExtension
            })
          }
        } else {
          this.screensbySite.forEach(async function (element, index, array){ 
            if (element.screens.length === 0 && !(index === (array.length - 1))) {
              return
            } else if (element.screens.length === 0 && index === (array.length - 1)) {
              this.$store.dispatch('setUploadSuccessful', true)
              this.$emit('close')
              this.$router.replace({
                name: 'MyContent'
              })
              return
            }
            var siteToUploadTo = element.site
            var selectedLandscapeScreens = element.screens.filter(function (screen){
              return screen.fk_screen_type === 1
            })
            var selectedPortraitScreens = element.screens.filter(function (screen){
              return screen.fk_screen_type === 2
            })
            var selectedLedScreens = element.screens.filter(function (screen){
              return screen.fk_screen_type === 3
            })
            var uploadSuccessful = true 
            if (!this.isPDF || !this.hasMultiplePages) {
              if (selectedLandscapeScreens.length > 0) {
                const responseLandscape = await FtpService.uploadImage({ b64: byteCharactersLandscape,
                  imageSettings: this.nameExtension,
                  site: siteToUploadTo,
                  screens: selectedLandscapeScreens,
                  uniqueID: uniqueID,
                  random: random
                })
                const responseLandscapeThumbnail = await FtpService.createThumbnail({ b64: byteThumbnailLandscape,
                  imageSettings: this.nameExtension,
                  site: siteToUploadTo,
                  screens: selectedLandscapeScreens,
                  uniqueID: uniqueID
                })
                if (responseLandscape) {
                  uploadSuccessful = uploadSuccessful && (responseLandscape.status === 200)
                }
              }
              if (selectedPortraitScreens.length > 0) {
                const responsePortrait = await FtpService.uploadImage({ b64: byteCharactersPortrait,
                  imageSettings: this.nameExtension,
                  site: siteToUploadTo,
                  screens: selectedPortraitScreens,
                  uniqueID: uniqueID,
                  random: random
                })
                const responsePortraitThumbnail = await FtpService.createThumbnail({ b64: byteThumbnailPortrait,
                  imageSettings: this.nameExtension,
                  site: siteToUploadTo,
                  screens: selectedPortraitScreens,
                  uniqueID: uniqueID,
                })
                if (responsePortrait) {
                  uploadSuccessful = uploadSuccessful && (responsePortrait.status === 200)
                }
              }
              if (selectedLedScreens.length > 0) {
                const responseLed = await FtpService.uploadImage({ b64: byteCharactersLed,
                  imageSettings: this.nameExtension,
                  site: siteToUploadTo,
                  screens: selectedLedScreens,
                  uniqueID: uniqueID,
                  random: random
                })
                const responseLedThumbnail = await FtpService.createThumbnail({ b64: byteThumbnailLed,
                  imageSettings: this.nameExtension,
                  site: siteToUploadTo,
                  screens: selectedLedScreens,
                  uniqueID: uniqueID
                })
                if (responseLed) {
                  uploadSuccessful = uploadSuccessful && (responseLed.status === 200)
                }
              }
              if (uploadSuccessful) {
                const dbResponse = await DBService.registerMediaProperties({
                  imageSettings: this.nameExtension,
                  site: siteToUploadTo,
                  screens: element.screens,
                  propertiesData: propertiesDataObject,
                  uniqueID: uniqueID,
                  user: this.$store.state.user.id,
                  isVideo: false,
                  random: random
                })
                if (dbResponse) {
                  if (dbResponse.status === 200 && index === (array.length - 1)) {
                    this.$store.dispatch('setUploadSuccessful', true)
                    this.$emit('close')
                    this.$router.replace({
                      name: 'MyContent'
                    })
                  }
                }
              } else {
                this.snackbarUploadFailed = true
              }
              
            } else {
              var parts = this.file.split('/')
              var pdfName = parts[2]
              var pdfUniqueID = pdfName.split('-0')[0]
              const responsePDFUpload = await FtpService.uploadMultiplePDF({
                uniqueID: pdfUniqueID,
                screens: selectedLandscapeScreens,
                dimension: '1366:768',
                site: siteToUploadTo,
                settings: this.nameExtension
              })
            }
          }, this)           
        }
      }
    },
    addScreen (screen) {
      this.chosenScreens.push(screen)
      this.availableScreens = this.currentSite.screens
      var nbOfSelectedScreens = 0
      var currSite = this.currentSite
      this.screensbySite.forEach(element => {
        if (element.site.SitId === currSite.SitId) {
          element.screens.push(screen)
        }
      })
      this.chosenScreens.forEach(function (element) {
        if (element.fk_site_id === currSite.SitId) 
          nbOfSelectedScreens++
      })
      this.allScreensFromCurrentSite = nbOfSelectedScreens === this.currentSite.screens.length
      this.allScreens = nbOfSelectedScreens === this.currentSite.screens.length
    },
    removeScreen (screen) {
      this.chosenScreens = this.chosenScreens.filter(function (element) {
        if (element.id !== screen.id) {
          return element
        }
      })
      var currSite = this.currentSite
      this.screensbySite.forEach(element => {
        if (element.site.SitId === currSite.SitId) {
          element.screens = element.screens.filter(screens => {
            if (screens.id !== screen.id) {
              return screens
            }
          })
        }
      })
      this.allScreens = false
      this.allScreensFromCurrentSite = false
    },
    addIcon (icon) {
      if (!this.selectedIcons.includes(icon)) {
        var imageObj = new Image()
        imageObj.onload = () => {
          var img = new Konva.Image({
            x: 0,
            y: 0,
            image: imageObj,            
            draggable: true,
            id: 'icon-' + icon.id
          })
          var imgLed, imgPortrait
          var initWidth = img.width()
          var initHeight = img.height()
          img.width(initWidth > initHeight ? initWidth * 130 / initWidth : initWidth * 130 / initHeight)
          img.height(initWidth > initHeight ? initHeight * 130 / initWidth : initHeight * 130 / initHeight)
          if (this.hasLandscapeScreens) {      
            landscapeLayer.add(img)
            landscapeLayer.draw()
          }
          if (this.hasPortraitScreens) {
            imgPortrait = img.clone()
            imgPortrait.width(imgPortrait.width() / itemPortraitScale)
            imgPortrait.height(imgPortrait.height() / itemPortraitScale)
            portraitLayer.add(imgPortrait)
            portraitLayer.draw()
          }
          if (this.hasLedScreens) {
            imgLed = img.clone()
            imgLed.width(imgLed.width() * 3 / 4)
            imgLed.height(imgLed.height() * 3 / 4)
            ledLayer.add(imgLed)
            ledLayer.draw()
          }
          landscapeStage.on('mouseup', () => {
            var originalAngle = img.rotation()
            rotateAroundCenter(img, 0)
            var margeDroiteMaxPaysage = 480 - (img.width() * img.scaleX())
            var margeBasseMaxPaysage = 270 - (img.height() * img.scaleY())
            var margeDroitePaysage = margeDroiteMaxPaysage - img.x()
            var margeBassePaysage = margeBasseMaxPaysage - img.y()
            if (this.hasPortraitScreens) {
              rotateAroundCenter(imgPortrait, 0)
              imgPortrait.scaleX(img.scaleX())
              imgPortrait.scaleY(img.scaleY())
              var widthTextPortrait = img.width() * img.scaleX() / itemPortraitScale
              var heightTextPortrait = img.height() * img.scaleY() / itemPortraitScale
              var margeDroiteMaxPortrait = 152 - widthTextPortrait
              var margeBasseMaxPortrait = 270 - heightTextPortrait
              var margeDroitePortrait = margeDroitePaysage * margeDroiteMaxPortrait / margeDroiteMaxPaysage
              var margeBassePortrait = margeBassePaysage * margeBasseMaxPortrait / margeBasseMaxPaysage
              var x0 = 152 - widthTextPortrait - margeDroitePortrait
              var y0 = 270 - heightTextPortrait - margeBassePortrait
              imgPortrait.x(x0)
              imgPortrait.y(y0)
              rotateAroundCenter(imgPortrait, originalAngle)
            }
            if (this.hasLedScreens) {
              rotateAroundCenter(imgLed, 0)
              imgLed.scaleX(img.scaleX())
              imgLed.scaleY(img.scaleY())
              var widthTextLed = img.width() * img.scaleX() * 3 / 4
              var heightTextLed = img.height() * img.scaleY() * 3 / 4
              var margeDroiteMaxLed = 360 - widthTextLed
              var margeBasseMaxLed = 252 - heightTextLed
              var margeDroiteLed = margeDroitePaysage * margeDroiteMaxLed / margeDroiteMaxPaysage
              var margeBasseLed = margeBassePaysage * margeBasseMaxLed / margeBasseMaxPaysage
              var x0Led = 360 - widthTextLed - margeDroiteLed
              var y0Led = 252 - heightTextLed - margeBasseLed
              imgLed.x(x0Led)
              imgLed.y(y0Led)
              rotateAroundCenter(imgLed, originalAngle)
            }
            rotateAroundCenter(img, originalAngle)
            drawLayer()
          })
        }
        imageObj.src = icon.longPath
        this.selectedIcons.push(icon)
      }
    },
    addEmoji(emoji) {
      if (!this.selectedEmojis.includes(emoji)) {
        var imageObj = new Image()
        imageObj.onload = () => {
          var img = new Konva.Image({
            x: 0,
            y: 0,
            image: imageObj,            
            draggable: true,
            id: 'emoji-' + emoji.id
          })
          var imgLed, imgPortrait
          var initWidth = img.width()
          var initHeight = img.height()
          img.width(initWidth > initHeight ? initWidth * 130 / initWidth : initWidth * 130 / initHeight)
          img.height(initWidth > initHeight ? initHeight * 130 / initWidth : initHeight * 130 / initHeight)
          if (this.hasLandscapeScreens) {      
            landscapeLayer.add(img)
            landscapeLayer.draw()
          }
          if (this.hasPortraitScreens) {
            imgPortrait = img.clone()
            imgPortrait.width(imgPortrait.width() / itemPortraitScale)
            imgPortrait.height(imgPortrait.height() / itemPortraitScale)
            portraitLayer.add(imgPortrait)
            portraitLayer.draw()
          }
          if (this.hasLedScreens) {
            imgLed = img.clone()
            imgLed.width(imgLed.width() * 3 / 4)
            imgLed.height(imgLed.height() * 3 / 4)
            ledLayer.add(imgLed)
            ledLayer.draw()
          }
          landscapeStage.on('mouseup', () => {
            var originalAngle = img.rotation()
            rotateAroundCenter(img, 0)
            var margeDroiteMaxPaysage = 480 - (img.width() * img.scaleX())
            var margeBasseMaxPaysage = 270 - (img.height() * img.scaleY())
            var margeDroitePaysage = margeDroiteMaxPaysage - img.x()
            var margeBassePaysage = margeBasseMaxPaysage - img.y()
            if (this.hasPortraitScreens) {
              rotateAroundCenter(imgPortrait, 0)
              imgPortrait.scaleX(img.scaleX())
              imgPortrait.scaleY(img.scaleY())
              var widthTextPortrait = img.width() * img.scaleX() / itemPortraitScale
              var heightTextPortrait = img.height() * img.scaleY() / itemPortraitScale
              var margeDroiteMaxPortrait = 152 - widthTextPortrait
              var margeBasseMaxPortrait = 270 - heightTextPortrait
              var margeDroitePortrait = margeDroitePaysage * margeDroiteMaxPortrait / margeDroiteMaxPaysage
              var margeBassePortrait = margeBassePaysage * margeBasseMaxPortrait / margeBasseMaxPaysage
              var x0 = 152 - widthTextPortrait - margeDroitePortrait
              var y0 = 270 - heightTextPortrait - margeBassePortrait
              imgPortrait.x(x0)
              imgPortrait.y(y0)
              rotateAroundCenter(imgPortrait, originalAngle)
            }
            if (this.hasLedScreens) {
              rotateAroundCenter(imgLed, 0)
              imgLed.scaleX(img.scaleX())
              imgLed.scaleY(img.scaleY())
              var widthTextLed = img.width() * img.scaleX() * 3 / 4
              var heightTextLed = img.height() * img.scaleY() * 3 / 4
              var margeDroiteMaxLed = 360 - widthTextLed
              var margeBasseMaxLed = 252 - heightTextLed
              var margeDroiteLed = margeDroitePaysage * margeDroiteMaxLed / margeDroiteMaxPaysage
              var margeBasseLed = margeBassePaysage * margeBasseMaxLed / margeBasseMaxPaysage
              var x0Led = 360 - widthTextLed - margeDroiteLed
              var y0Led = 252 - heightTextLed - margeBasseLed
              imgLed.x(x0Led)
              imgLed.y(y0Led)
              rotateAroundCenter(imgLed, originalAngle)
            }
            rotateAroundCenter(img, originalAngle)
            drawLayer()
          })
        }
        imageObj.src = emoji.longPath
        this.selectedEmojis.push(emoji)
      }
    },
    removeIcon (icon) {
      if (this.hasLandscapeScreens) {
        landscapeLayer.find('#icon-' + icon.id).destroy()   
      }
      if (this.hasPortraitScreens) {
        portraitLayer.find('#icon-' + icon.id).destroy()   
      }
      if (this.hasLedScreens) {
        ledLayer.find('#icon-' + icon.id).destroy()
      }
       this.selectedIcons = this.selectedIcons.filter(function (element) {
          if (element.id !== icon.id) {
            return element
          }
        })
      drawLayer()
    },
    removeEmoji (emoji) {
      if (this.hasLandscapeScreens) {
        landscapeLayer.find('#emoji-' + emoji.id).destroy()   
      }
      if (this.hasPortraitScreens) {
        portraitLayer.find('#emoji-' + emoji.id).destroy()   
      }
      if (this.hasLedScreens) {
        ledLayer.find('#emoji-' + emoji.id).destroy()
      }
       this.selectedEmojis = this.selectedEmojis.filter(function (element) {
          if (element.id !== emoji.id) {
            return element
          }
        })
      drawLayer()
    },
    removePrice (priceBlockID) {
      this.priceBlocks = this.priceBlocks.filter(function (element) {
        if (element.id !== priceBlockID) {
          return element
        }
      })
    },
    removeTextBlock (textBlockID) {
      this.textBlocks = this.textBlocks.filter(function (element) {
        if (element.id !== textBlockID) {
          return element
        }
      })
    },
    removeHours () {
      this.setBroadCastHours = false
      this.endingHour.HH = ''
      this.endingHour.mm = '00'
      this.startingHour.HH = ''
      this.startingHour.mm = '00'
      this.isEndingHourValid = false
      this.isStartingHourValid = false
    },
    setSources () {    
      if (!this.$store.state.mediaToEdit) {
        if (this.hasLandscapeScreens) {
          landscapeStage = new Konva.Stage({
            container: 'landscapeCanvas',
            width: 480,
            height: 270
          })
          landscapeLayer = new Konva.Layer()
        }
        if (this.hasPortraitScreens) {
          portraitStage = new Konva.Stage({
            container: 'portraitCanvas',
            width: 152,
            height: 270
          })
          portraitLayer = new Konva.Layer()
        }
        if (this.hasLedScreens) {
          ledStage = new Konva.Stage({
            container: 'ledCanvas',
            width: 360,
            height: 270
          })
          ledLayer = new Konva.Layer()
        }
        new Konva.Image.fromURL(this.imageURL, (image) => {
          if (this.hasLandscapeScreens) {
            if (this.$store.state.pixabayImageID !== 0) {
              this.currentSelectedLandscapeFraming = 2
              landscapeLayer.find('#landscapeBackground').destroy()
              landscapeLayer.find('#blurredLandscapeBackground').destroy()
              let newWidth = 1366
              let newHeight = image.size().height / (image.size().width / 1366)

              var yCanvasPos = (768 - newHeight) * landscapeScale / 2
              var landscapeImage = image.clone()

              landscapeImage.size({
                width: newWidth,
                height: newHeight
              })

              landscapeImage.x(0)
              landscapeImage.y(yCanvasPos)
              landscapeImage.scaleX(landscapeScale)
              landscapeImage.scaleY(landscapeScale)
              landscapeImage.id('landscapeBackground')
              landscapeLayer.add(landscapeImage)
              landscapeImage.moveToBottom()
              landscapeStage.add(landscapeLayer)
              landscapeLayer.draw()    
            } else {
              this.currentSelectedLandscapeFraming = 1
              new Konva.Image.fromURL(this.imageURL, (image) => {
                landscapeLayer.find('#landscapeBackground').destroy()
                landscapeLayer.find('#blurredLandscapeBackground').destroy()
                let newWidth, newHeight
                if (image.size().width < 1366 && image.size().height < 768) {
                  newWidth = image.size().width
                  newHeight = image.size().height
                } else {
                  let widthDiff = image.size().width / 1366
                  let heightDiff = image.size().height / 768
                  let biggestDiff = widthDiff > heightDiff ? widthDiff : heightDiff
                  newWidth = image.size().width / biggestDiff
                  newHeight = image.size().height / biggestDiff
                }
                var landscapeImage = image.clone()
                var backgroundLandscapeImage
                if (this.hasBackgroundColor) {
                  var backgroundLandscapeImage = new Konva.Rect({
                    width: 480,
                    height: 270,
                    fill: this.selectedBackgroundColor
                  })
                } else {
                  backgroundLandscapeImage = image.clone()
                  backgroundLandscapeImage.size({
                    width: 480,
                    height: 270
                  })
                  backgroundLandscapeImage.cache()
                  backgroundLandscapeImage.filters([Konva.Filters.Blur])
                  backgroundLandscapeImage.blurRadius(blurRadius)
                }
                
                landscapeLayer.add(backgroundLandscapeImage)
                backgroundLandscapeImage.id('blurredLandscapeBackground')
                landscapeImage.size({
                  width: newWidth,
                  height: newHeight
                })
                landscapeImage.x(((1366 - newWidth) * landscapeScale) / 2)
                landscapeImage.y(((768 - newHeight) * landscapeScale) / 2)
                landscapeImage.scaleX(landscapeScale)
                landscapeImage.scaleY(landscapeScale)
                landscapeImage.id('landscapeBackground')
                landscapeLayer.add(landscapeImage)
                landscapeImage.moveToBottom()
                backgroundLandscapeImage.moveToBottom()   
                landscapeStage.add(landscapeLayer)
                landscapeLayer.draw()             
              })
            }
            
            
          }
          if (this.hasPortraitScreens) {
            if (this.$store.state.pixabayImageID !== 0) {
              this.currentSelectedPortraitFraming = 2
              portraitLayer.find('#portraitBackground').destroy()
              portraitLayer.find('#blurredPortraitBackground').destroy()
              let newHeight = 1366
              let newWidth = image.size().width / (image.size().height / 1366)

              var xCanvasPos = (768 - newWidth) * imagePortraitScale / 2
              var portraitImage = image.clone()

              portraitImage.size({
                width: newWidth,
                height: newHeight
              })
              portraitImage.x(xCanvasPos)
              portraitImage.y(0)
              portraitImage.scaleX(imagePortraitScale)
              portraitImage.scaleY(imagePortraitScale)
              portraitImage.id('portraitBackground')
              portraitLayer.add(portraitImage)
              portraitImage.moveToBottom()
              portraitStage.add(portraitLayer)
              portraitLayer.draw()
            } else {
              this.currentSelectedPortraitFraming = 1
              new Konva.Image.fromURL(this.imageURL, (image) => {
                portraitLayer.find('#portraitBackground').destroy()
                portraitLayer.find('#blurredPortraitBackground').destroy()
                let newWidth, newHeight
                if (image.size().width < 768 && image.size().height < 1366) {
                  newWidth = image.size().width
                  newHeight = image.size().height
                } else {
                  let widthDiff = image.size().width / 768
                  let heightDiff = image.size().height / 1366
                  let biggestDiff = widthDiff > heightDiff ? widthDiff : heightDiff
                  newWidth = image.size().width / biggestDiff
                  newHeight = image.size().height / biggestDiff
                }
                var portraitImage = image.clone()
                var blurredPortraitImage
                if (this.hasBackgroundColor) {
                  backgroundPortraitImage = new Konva.Rect({
                    width: 152,
                    height: 270,
                    fill: this.selectedBackgroundColor
                  })
                } else {
                  blurredPortraitImage = image.clone()
                  blurredPortraitImage.size({
                    width: 152,
                    height: 270
                  })
                  blurredPortraitImage.cache()
                  blurredPortraitImage.filters([Konva.Filters.Blur])
                  blurredPortraitImage.blurRadius(blurRadius)
                }
                blurredPortraitImage.id('blurredPortraitBackground')
                portraitLayer.add(blurredPortraitImage)
                portraitImage.size({
                  width: newWidth,
                  height: newHeight
                })
                portraitImage.x(((768 - newWidth) * imagePortraitScale) / 2)
                portraitImage.y(((1366 - newHeight) * imagePortraitScale) / 2)
                portraitImage.scaleX(imagePortraitScale)
                portraitImage.scaleY(imagePortraitScale)
                portraitImage.id('portraitBackground')
                portraitLayer.add(portraitImage)
                portraitImage.moveToBottom()
                blurredPortraitImage.moveToBottom()
                portraitStage.add(portraitLayer)
                portraitLayer.draw()
              })
            }          
          }
          if (this.hasLedScreens) {
            let x0 = 0
            let y0 = 0
            ledLayer.find('#landscapeBackground').destroy()
            ledLayer.find('#blurredLandscapeBackground').destroy()
            let widthDiff = image.size().width / 360
            let heightDiff = image.size().height / 270
            let lowestDiff = widthDiff > heightDiff ? heightDiff : widthDiff
            let newWidth = image.size().width / lowestDiff
            let newHeight = image.size().height / lowestDiff
            if (newHeight > 270) {
              y0 = (270 - newHeight) / 2
            } else if (newWidth > 360) {
              x0 = (360 - newWidth) / 2
            }
            var ledImage = image.clone()
            ledImage.size({
              width: newWidth,
              height: newHeight
            })
            ledImage.x(x0)
            ledImage.y(y0)
            ledImage.id('ledBackground')
            ledLayer.add(ledImage)
            ledStage.add(ledLayer)
            ledLayer.draw()
          }
          this.doneFetchingImage = true     
        })
        if (this.hasLandscapeScreens){
          landscapeStage.on('click tap', function (e) {
            landscapeStage.find('Transformer').destroy()
            var target = e.target
            var targetID = target.attrs.id
            if (targetID) {
              if (target.parent === undefined || targetID.toLowerCase().includes('background') || targetID.toLowerCase().includes('banner')) {
                landscapeStage.find('Transformer').destroy()
                landscapeStage.draw()
                return
              }
            }
            if (target.parent.nodeType === 'Group') {
              let tr = new Konva.Transformer({
                node: target.parent,
                keepRatio: true,
                enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
                anchorSize: 15,
                rotateEnabled: false
              })
              landscapeLayer.add(tr)
              tr.attachTo(target.parent)
              landscapeLayer.draw()
            } else {
              let tr = new Konva.Transformer({
                node: target,
                keepRatio: true,
                enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
                anchorSize: 15,
                rotateAnchorOffset: 30,
                rotationSnaps: [0, 90, 180, 270]
              })
              landscapeLayer.add(tr)
              tr.attachTo(target)
              landscapeLayer.draw()
            }
          })
        }
      } else {
        axios.get('https://pixabay.com/api/?key=55785-5311f6dc11479d2611e5df625&id=' + this.$store.state.mediaToEdit.pixabay_id)
          .then((response) => {
            var imageData = response.data.hits
            this.imageURL = imageData[0].imageURL
            new Konva.Image.fromURL(imageData[0].imageURL, (image) => {
              if (this.hasLandscapeScreens) {
                landscapeStage = new Konva.Stage({
                  container: 'landscapeCanvas',
                  width: 480,
                  height: 270
                })
                
                landscapeLayer = Konva.Node.create(this.$store.state.mediaToEdit.json_data_canvas)
                landscapeLayer.add(image)
                image.moveToBottom()
                landscapeStage.add(landscapeLayer)
                image.id('landscapeBackground')
                
                if (this.$store.state.mediaToEdit.cadrage_paysage === 1) {
                  this.landscapeFullImage()
                } else if (this.$store.state.mediaToEdit.cadrage_paysage === 2) {
                  this.landscapeCenterPosition()
                } else if (this.$store.state.mediaToEdit.cadrage_paysage === 3) {
                  this.landscapeBottomPosition()
                } else if (this.$store.state.mediaToEdit.cadrage_paysage === 4) {
                  this.landscapeTopPosition()
                } else {
                  this.landscapeFullImage()
                }
                this.doneFetchingImage = true
                landscapeStage.on('click tap', function (e) {
                  landscapeStage.find('Transformer').destroy()
                  var target = e.target
                  var targetID = target.attrs.id
                  if (targetID) {
                    if (target.parent === undefined || targetID.toLowerCase().includes('background')) {
                      landscapeStage.find('Transformer').destroy()
                      landscapeStage.draw()
                      return
                    }
                  }
                  if (target.parent.nodeType === 'Group') {
                    let tr = new Konva.Transformer({
                      node: target.parent,
                      keepRatio: true,
                      enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
                      anchorSize: 15,
                      rotateEnabled: false
                    })
                    landscapeLayer.add(tr)
                    tr.attachTo(target.parent)
                    landscapeLayer.draw()
                  } else {
                    let tr = new Konva.Transformer({
                      node: target,
                      keepRatio: true,
                      enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
                      anchorSize: 15,
                      rotateAnchorOffset: 30,
                      rotationSnaps: [0, 90, 180, 270]
                    })
                    landscapeLayer.add(tr)
                    tr.attachTo(target)
                    landscapeLayer.draw()
                  }
                })
              }
              if (this.hasPortraitScreens) {
                 portraitStage = new Konva.Stage({
                  container: 'portraitCanvas',
                  width: 152,
                  height: 270
                })
                if (this.hasTwoByFourScreens) {
                  portraitStage.width(76)
                }
                var portraitImage = image.clone()
                portraitLayer = Konva.Node.create(this.$store.state.mediaToEdit.json_data_canvas_portrait)
                portraitLayer.add(portraitImage)
                portraitImage.moveToBottom()
                portraitStage.add(portraitLayer)
                portraitImage.id('portraitBackground')
                
                if (this.$store.state.mediaToEdit.cadrage_portrait === 1) {
                  this.portraitFullImage()
                } else if (this.$store.state.mediaToEdit.cadrage_portrait === 2) {
                  this.portraitCenterPosition()
                } else if (this.$store.state.mediaToEdit.cadrage_portrait === 3) {
                  this.portraitLeftPosition()
                } else if (this.$store.state.mediaToEdit.cadrage_portrait === 4) {
                  this.portraitRightPosition()
                } else {
                  this.portraitFullImage()
                }
                this.doneFetchingImage = true
              }
            })
          })
      }
     
    },
    landscapeTopPosition () {
      this.currentSelectedLandscapeFraming = 4
      new Konva.Image.fromURL(this.imageURL, (image) => {
        landscapeLayer.find('#landscapeBackground').destroy()
        landscapeLayer.find('#blurredLandscapeBackground').destroy()

        let newWidth = 1366
        let newHeight = image.size().height / (image.size().width / 1366)
        var landscapeImage = image.clone() 
        landscapeImage.size({
          width: newWidth,
          height: newHeight
        })
        landscapeImage.x(0)
        landscapeImage.y(0)
        landscapeImage.scaleX(landscapeScale)
        landscapeImage.scaleY(landscapeScale)
        landscapeImage.id('landscapeBackground')
        landscapeLayer.add(landscapeImage)
        landscapeImage.moveToBottom()
        landscapeLayer.draw()
      })
    },
    landscapeBottomPosition () {
      this.currentSelectedLandscapeFraming = 3
      new Konva.Image.fromURL(this.imageURL, (image) => {
        landscapeLayer.find('#landscapeBackground').destroy()
        landscapeLayer.find('#blurredLandscapeBackground').destroy()
        let newWidth = 1366
        let newHeight = image.size().height / (image.size().width / 1366)

        var yCanvasPos = (768 - newHeight) * landscapeScale
        var landscapeImage = image.clone()

        landscapeImage.size({
          width: newWidth,
          height: newHeight
        })
        landscapeImage.x(0)
        landscapeImage.y(yCanvasPos)
        landscapeImage.scaleX(landscapeScale)
        landscapeImage.scaleY(landscapeScale)
        landscapeImage.id('landscapeBackground')
        landscapeLayer.add(landscapeImage)
        landscapeImage.moveToBottom()
        landscapeLayer.draw()
      })
    },
    landscapeCenterPosition () {
      this.currentSelectedLandscapeFraming = 2
      new Konva.Image.fromURL(this.imageURL, (image) => {
        landscapeLayer.find('#landscapeBackground').destroy()
        landscapeLayer.find('#blurredLandscapeBackground').destroy()
        let newWidth = 1366
        let newHeight = image.size().height / (image.size().width / 1366)

        var yCanvasPos = (768 - newHeight) * landscapeScale / 2
        var landscapeImage = image.clone()

        landscapeImage.size({
          width: newWidth,
          height: newHeight
        })

        landscapeImage.x(0)
        landscapeImage.y(yCanvasPos)
        landscapeImage.scaleX(landscapeScale)
        landscapeImage.scaleY(landscapeScale)
        landscapeImage.id('landscapeBackground')
        landscapeLayer.add(landscapeImage)
        landscapeImage.moveToBottom()
        landscapeLayer.draw()    
      })
    },
    landscapeFullImage () {
      this.currentSelectedLandscapeFraming = 1
      new Konva.Image.fromURL(this.imageURL, (image) => {
        landscapeLayer.find('#landscapeBackground').destroy()
        landscapeLayer.find('#blurredLandscapeBackground').destroy()
        let newWidth, newHeight
        if (image.size().width < 1366 && image.size().height < 768) {
          newWidth = image.size().width
          newHeight = image.size().height
        } else {
          let widthDiff = image.size().width / 1366
          let heightDiff = image.size().height / 768
          let biggestDiff = widthDiff > heightDiff ? widthDiff : heightDiff
          newWidth = image.size().width / biggestDiff
          newHeight = image.size().height / biggestDiff
        }
        var landscapeImage = image.clone()
        var backgroundLandscapeImage
        if (this.hasBackgroundColor) {
          var backgroundLandscapeImage = new Konva.Rect({
            width: 480,
            height: 270,
            fill: this.selectedBackgroundColor
          })
        } else {
          backgroundLandscapeImage = image.clone()
          backgroundLandscapeImage.size({
            width: 480,
            height: 270
          })
          backgroundLandscapeImage.cache()
          backgroundLandscapeImage.filters([Konva.Filters.Blur])
          backgroundLandscapeImage.blurRadius(blurRadius)
        }
        
        landscapeLayer.add(backgroundLandscapeImage)
        backgroundLandscapeImage.id('blurredLandscapeBackground')
        landscapeImage.size({
          width: newWidth,
          height: newHeight
        })
        landscapeImage.x(((1366 - newWidth) * landscapeScale) / 2)
        landscapeImage.y(((768 - newHeight) * landscapeScale) / 2)
        landscapeImage.scaleX(landscapeScale)
        landscapeImage.scaleY(landscapeScale)
        landscapeImage.id('landscapeBackground')
        landscapeLayer.add(landscapeImage)
        landscapeImage.moveToBottom()
        backgroundLandscapeImage.moveToBottom()
        landscapeLayer.draw()
      })
    },
    colorLandscapeBackground () {
      landscapeLayer.find('#blurredLandscapeBackground').destroy()
      var backgroundLandscapeImage = new Konva.Rect({
        width: 480,
        height: 270,
        fill: this.selectedBackgroundColor
      })
      landscapeLayer.add(backgroundLandscapeImage)
      backgroundLandscapeImage.id('blurredLandscapeBackground')
      backgroundLandscapeImage.moveToBottom()
      setTimeout(drawLayer, 600)
    },
    portraitRightPosition () {
      this.currentSelectedPortraitFraming = 4
      new Konva.Image.fromURL(this.imageURL, (image) => {
        portraitLayer.find('#portraitBackground').destroy()
        portraitLayer.find('#blurredPortraitBackground').destroy()
        let newHeight = 1366
        let newWidth = image.size().width / (image.size().height / 1366)

        var xCanvasPos = (768 - newWidth) * imagePortraitScale
        var portraitImage = image.clone()

        portraitImage.size({
          width: newWidth,
          height: newHeight
        })
        portraitImage.x(xCanvasPos)
        portraitImage.y(0)
        portraitImage.scaleX(imagePortraitScale)
        portraitImage.scaleY(imagePortraitScale)
        portraitImage.id('portraitBackground')
        portraitLayer.add(portraitImage)
        portraitImage.moveToBottom()
        portraitLayer.draw()
      })
    },
    portraitLeftPosition () {
      this.currentSelectedPortraitFraming = 3
      new Konva.Image.fromURL(this.imageURL, (image) => {
        portraitLayer.find('#portraitBackground').destroy()
        portraitLayer.find('#blurredPortraitBackground').destroy()
        let newHeight = 1366
        let newWidth = image.size().width / (image.size().height / 1366)
        var xCanvasPos = (768 - newWidth) * imagePortraitScale
        var portraitImage = image.clone()
       
        portraitImage.size({
          width: newWidth,
          height: newHeight
        })
        portraitImage.x(0)
        portraitImage.y(0)
        portraitImage.scaleX(imagePortraitScale)
        portraitImage.scaleY(imagePortraitScale)
        portraitImage.id('portraitBackground')
        portraitLayer.add(portraitImage)
        portraitImage.moveToBottom()
        portraitLayer.draw()
      })
    },
    portraitCenterPosition () {
      this.currentSelectedPortraitFraming = 2
      new Konva.Image.fromURL(this.imageURL, (image) => {
        portraitLayer.find('#portraitBackground').destroy()
        portraitLayer.find('#blurredPortraitBackground').destroy()
        let newHeight = 1366
        let newWidth = image.size().width / (image.size().height / 1366)

        var xCanvasPos = (768 - newWidth) * imagePortraitScale / 2
        var portraitImage = image.clone()

        portraitImage.size({
          width: newWidth,
          height: newHeight
        })
        portraitImage.x(xCanvasPos)
        portraitImage.y(0)
        portraitImage.scaleX(imagePortraitScale)
        portraitImage.scaleY(imagePortraitScale)
        portraitImage.id('portraitBackground')
        portraitLayer.add(portraitImage)
        portraitImage.moveToBottom()
        portraitLayer.draw()
      })
    },
    portraitFullImage () {
      this.currentSelectedPortraitFraming = 1
      new Konva.Image.fromURL(this.imageURL, (image) => {
        portraitLayer.find('#portraitBackground').destroy()
        portraitLayer.find('#blurredPortraitBackground').destroy()
        let newWidth, newHeight
        if (image.size().width < 768 && image.size().height < 1366) {
          newWidth = image.size().width
          newHeight = image.size().height
        } else {
          let widthDiff = image.size().width / 768
          let heightDiff = image.size().height / 1366
          let biggestDiff = widthDiff > heightDiff ? widthDiff : heightDiff
          newWidth = image.size().width / biggestDiff
          newHeight = image.size().height / biggestDiff
        }
        var portraitImage = image.clone()
        var blurredPortraitImage
        if (this.hasBackgroundColor) {
          blurredPortraitImage = new Konva.Rect({
            width: 152,
            height: 270,
            fill: this.selectedBackgroundColor
          })
        } else {
          blurredPortraitImage = image.clone()
          blurredPortraitImage.size({
            width: 152,
            height: 270
          })
          blurredPortraitImage.cache()
          blurredPortraitImage.filters([Konva.Filters.Blur])
          blurredPortraitImage.blurRadius(blurRadius)
        }
        blurredPortraitImage.id('blurredPortraitBackground')
        portraitLayer.add(blurredPortraitImage)
        portraitImage.size({
          width: newWidth,
          height: newHeight
        })
        portraitImage.x(((768 - newWidth) * imagePortraitScale) / 2)
        portraitImage.y(((1366 - newHeight) * imagePortraitScale) / 2)
        portraitImage.scaleX(imagePortraitScale)
        portraitImage.scaleY(imagePortraitScale)
        portraitImage.id('portraitBackground')
        portraitLayer.add(portraitImage)
        portraitImage.moveToBottom()
        blurredPortraitImage.moveToBottom()
        portraitLayer.draw()
      })
    },
    colorPortraitBackground () {
      portraitLayer.find('#blurredPortraitBackground').destroy()
      var backgroundPortraitImage = new Konva.Rect({
        width: 152,
        height: 270,
        fill: this.selectedBackgroundColor
      })
      portraitLayer.add(backgroundPortraitImage)
      backgroundPortraitImage.id('blurredPortraitBackground') 
      backgroundPortraitImage.moveToBottom()
      setTimeout(drawLayer, 600)
    },
    setColorPickerVisibility () {
      this.colorVisible = !this.colorVisible
    },
    screenIcon (screenType) {
      if (screenType === 1) {
        return this.imgSrcLandscape
      } else if (screenType === 2 || screenType === 4) {
        return this.imgSrcPortrait
      } else if (screenType === 3) {
        return this.imgSrcLED
      }
    }
  },
  computed: {
    schedule: function () {
      if (this.endingDate) {
        return 'du ' + this.startingDate + '<br> au ' + this.endingDate
      } else {
        return 'à partir du ' + this.startingDate
      }
    },
    hours: function () {
      if (this.startingHour.HH && this.startingHour.mm && this.endingHour.HH && this.endingHour.mm) {
        return 'entre ' + this.startingHour.HH + ':' + this.startingHour.mm + ' et ' + this.endingHour.HH + ':' + this.endingHour.mm
      } else {
        return ''
      }
    },
    orderedDays: function () {
      var days = []
      var returnValue = ''
      for (let i = 0; i < this.chosenDays.length; i++) {
        if (this.chosenDays[i].id === 0) {
          return this.chosenDays[i].name
        } else {
          days = this.chosenDays.slice().sort(compareById)
          days.forEach(function(element) {
            returnValue += element.name + ', '
          })
          return returnValue.substring(0, returnValue.length-2)
        }
      }
    },
    screenList: function () {
      var screenList = ''
      for (let i = 0; i < this.chosenScreens.length; i++) {
       screenList += this.chosenScreens[i].server_name + ', '
      }
      return screenList.substring(0, screenList.length-2)
    }
  },
  watch: {
    banner: function () {
      if (this.banner) {
        var landscapeBanner = this.landscapeBanner
        var portraitBanner = this.portraitBanner
        var ledBanner = this.ledBanner
        if (this.hasLandscapeScreens) {
          new Konva.Image.fromURL(landscapeBanner, (image) => {
            image.size({
              width: 480,
              height: 270
            })
            image.id('banner')
            landscapeLayer.add(image)
            landscapeLayer.draw()
          })
        }
        if (this.hasPortraitScreens) {
          new Konva.Image.fromURL(portraitBanner, (image) => {
            image.size({
              width: 152,
              height: 270
            })
            image.id('banner')
            portraitLayer.add(image)
            portraitLayer.draw()
          })
        }
        if (this.hasLedScreens) {
          new Konva.Image.fromURL(ledBanner, (image) => {
            image.size({
              width: 360,
              height: 270
            })
            image.id('banner')
            ledLayer.add(image)
            ledLayer.draw()
          })
        }
      } else {
        if (this.hasLandscapeScreens) {
          landscapeLayer.find('#banner').destroy()
        }
        if (this.hasPortraitScreens) {
          portraitLayer.find('#banner').destroy()
        }
        if (this.hasLedScreens) {
          ledLayer.find('#banner').destroy()
        }     
        drawLayer()
      }
    },
    currentSite: function () {
      this.availableScreens = this.currentSite.screens
      var nbOfSelectedScreens = 0
      var currSite = this.currentSite
      this.chosenScreens.forEach(function (element) {
        if (element.fk_site_id === currSite.SitId) 
          nbOfSelectedScreens++
      })
      this.allScreensFromCurrentSite = nbOfSelectedScreens === this.currentSite.screens.length
    },
    allGroups: function () {
      this.selectedCultura = this.allGroups ? this.tempCultura : []
    },
    startingHour: function () {
      if (!this.setBroadCastHours) {
        this.isStartingHourValid = true
      } else if (!(this.startingHour.HH !== '' && this.startingHour.mm !== '')) {
        this.isStartingHourValid = false
      } else {
        this.isStartingHourValid = true
      }
    },
    endingHour: function () {
      if (!this.setBroadCastHours) {
        this.isEndingHourValid = true
      } else if (!(this.endingHour.HH !== '' && this.endingHour.mm !== '')) {
        this.isEndingHourValid = false
      } else {
        this.isEndingHourValid = true
      }
    },
    chosenDays: function () {
      for (let i = 0; i < this.chosenDays.length; i++) {
        if (this.chosenDays[i].id === 0 && this.chosenDays.length > 1) {
          this.chosenDays.splice(i, 1)
          break
        }
      }
    },
    stepModel: function () {
      this.animationStyle = this.stepModel > 1 ? 'transform: scale(0);-ms-transform: scale(0); transition: transform 300ms' : 'transform:scale(1);-ms-transform:scale(1); transition: transform 300ms; transition-delay: 500ms;'
      this.imageStyle = this.stepModel > 1 ? ' transform: scale(1);-ms-transform: scale(1); transition: transform 300ms;' : 'transform:scale(0); -ms-transform:scale(0); transition: transform 300ms;'
    },
    selectedBackgroundColor: function() {
      if (this.hasLandscapeScreens)
        this.colorLandscapeBackground()
      if (this.hasPortraitScreens)
        this.colorPortraitBackground()
    },
    hasBackgroundColor: function () {
      if (this.hasBackgroundColor) {
        if (this.hasLandscapeScreens) {
          this.colorLandscapeBackground()
        }
        if (this.hasPortraitScreens){
          this.colorPortraitBackground()
        }
      } else {
        switch(this.currentSelectedLandscapeFraming) {
          case 1:
            this.landscapeFullImage()
            break
          case 2:
            this.landscapeCenterPosition()
            break
          case 3:
            this.landscapeBottomPosition()
            break
          case 4:
            this.landscapeTopPosition()
            break
          default: 
            this.landscapeFullImage()
        }

        switch(this.currentSelectedPortraitFraming) {
          case 1:
            this.portraitFullImage()
            break
          case 2:
            this.portraitCenterPosition()
            break
          case 3:
            this.portraitLeftPosition()
            break
          case 4:
            this.portraitRightPosition()
            break
          default: 
            this.portraitFullImage()
        }
      }
    }
  }
}

function drawLayer () {
  if (landscapeLayer) {
    landscapeLayer.draw()
  }
  if (portraitLayer) {
    portraitLayer.draw()
  }
  if (ledLayer) {
    ledLayer.draw()
  }
}

var rotatePoint = ({
  x,
  y
}, rad) => {
  const rcos = Math.cos(rad)
  const rsin = Math.sin(rad)
  return {
    x: x * rcos - y * rsin,
    y: y * rcos + x * rsin
  }
}

function rotateAroundCenter (node, rotation) {
  //  current rotation origin (0, 0) relative to desired origin - center (node.width()/2, node.height()/2)
  const topLeft = {
    x: -node.width() * node.scaleX() / 2,
    y: -node.height() * node.scaleY() / 2
  }
  const current = rotatePoint(topLeft, Konva.getAngle(node.rotation()))
  const rotated = rotatePoint(topLeft, Konva.getAngle(rotation))
  const dx = rotated.x - current.x
  const dy = rotated.y - current.y

  node.rotation(rotation)
  node.x(node.x() + dx)
  node.y(node.y() + dy)
}

function compareById (a, b) {
  if (a.id < b.id) {
    return -1
  }
  if (a.id > b.id) {
    return 1
  }
  return 0
}
</script>

<style scoped>


.vert-align-top{
  vertical-align: top;
}

.divBlock{
  overflow-x:auto;
  overflow-y:visible!important;
  display:flex!important;
  flex-direction:row!important;
  width:100%;
  height: 246px;
  align-items: center;
}

.divAddBlock{
  display: block;
  overflow-y: visible;
}

.divObject{
  vertical-align: top;
  /* display: inline-block; */
  display: flex;
  margin-right: 14px;
/*   background-color:rgba(85, 86, 94, 0.10);
 */  background-color: rgba(9, 5, 33,0.1);
  height:36px;
  width:auto;
  border-radius:50em;
}

.icon-list {
/* background-color: var(--v-contrast-base)!important;*/
  height: 246px;
  overflow:auto;
  padding: 4px;
}

.icon-list-item{
  position:relative;
  height: 100px!important;
  width: 100px!important;
  margin:4px;
}

.form-checkbox {
  margin: auto;
  display: flex;
/*   display: block;
 */  margin-right: 10px;
  padding-top:0px!important;
  margin-left:-2px!important;
}

.div-align-top{
  vertical-align: top;
}

.broadcast-days-div{
  max-width: 500px;
}

.btnAddContent{
  height: 25px;
  width: 25px;
}

.select-screen-container{
  position:relative;
  width:180px!important;
  height:180px!important;
/*   background-color: lightblue;
 */}

.theme--light .select-screen-image-bloc{
  width:100px!important;
  height:100px!important;
  border-radius:50em;
  margin-bottom:16px;
  background-color:var(--v-primary-base);
}

.theme--dark .select-screen-image-bloc{
  width:100px!important;
  height:100px!important;
  border-radius:50em;
  margin-bottom:16px;
  background-color: rgb(37, 39, 53);
}

.select-screen-image{
  overflow:visible;
  cursor:pointer;
  height:100%;
  width:100%;
}

.select-screen-button{
  height:30px;
  width:30px;
  position:absolute;
  z-index:1;
  bottom:0;
  right:0;
/*   cursor: initial;
 */}

</style>